export default {
	DecimalPrecision: 3,
	MerchantReportName: "MERCHANT_REPORT",
	LottoCategory: {
		ShiShiCai: 1,
		FenFenCai: 2,
		MiaoMiaoCai: 3,
		ElevenXFive: 4,
		FenFenElevenXFive: 5,
		MiaoMiaoElevenXFive: 6,
		FuCai3D: 7,
		FenFenFuCai3D: 8,
		P3P5: 9,
		FenFenP3P5: 10,
		Kuai3: 11,
		FenFenKuai3: 12,
		MiaoMiaoKuai3: 13,
		KuaiKai: 14,
		FenFenKuaiKai: 15,
		MiaoMiaoKuaiKai: 16,
		Happy8: 17,
		FenFenHappy8: 18,
		KuaiLe10: 19,
		FenFenKuaiLe10: 20,
		Lucky28: 21,
		FenFenLucky28: 22,
		KENO: 23,
		KENO3D: 24,
		ShaiBao: 25,
		FenFenShaiBao: 26,
		MiaoMiaoShaiBao: 27,
		QiXingCai: 28,
		Baccarat: 29,
		VRLottery: 30,
		AG: 31,
		AS: 32,
		AVIA: 33,
		BBin: 34,
		BIO: 35,
		CMD: 36,
		DG: 37,
		EBET: 38,
		GAMMA: 39,
		GD: 40,
		GG: 41,
		JDB: 42,
		KG: 43,
		KY: 44,
		MG: 45,
		PG: 46,
		PT: 47,
		SA: 48,
		TGP: 49,
		UG: 50,
		YC: 51,
		YLB: 52,
		VRGame: 53,
		CQ9: 55,
		FC: 57,
		IM: 58,
		DONGSEN: 59,
		LEG: 60,
		TM: 61,
		YB: 62,
		BBin2: 63,
		SB: 64,
		IBO: 65,
		DREAMWORK: 66,
		CR: 67,
		XBB: 68,
		KENO2: 69,
		EGP_AG: 70,
		EGP_KY: 71,
		EGP_BBIN: 72,
		EGP_CR: 73,
		EGP_AWC: 74,
		EGP_JDB: 75,
		EGP_CQ9: 76,
		DuelLottery: 77,
		GDQ: 78,
		EGP_SB: 79,
		TG: 80,
		ICG: 81,
		EGP_FC: 82,
		Predict: 83,
		VirtualCoin: 84,
		WALI: 85,
		CT: 86,
		GR: 87,
		ALLBET: 88,
		BlockChainHash: 89,
		TronHash: 90,
		PP: 91,
		BTI: 92,
		BlockChainHashCai: 93,
		WM: 94,
		IM_SW: 95,
		CR_SW: 96,
		OBSPORT_SW: 97,
		MarkSix: 98,
		BAISON: 99,
		CG_SW: 100,
		PMLIVE_SW: 101,
		HRG_SW: 102,
		CARD86: 103,
		GC_SW: 104,
		BG: 105,
		WE: 106,
		HRG: 107,
		ZZSIX: 108,
		AnimalOlympic: 109,
		EGP_LEG: 110,
		SING3: 111,
		TIKI: 112,
		BTI2: 113,
		WuSanJiu: 114,
		VRGame_SW: 115,
		DBGAME_SW: 116,
		SPRIBE_SW: 117,
		MWGAMES: 118,
		TCQXC: 119,
		TCDLT: 120,
		FCSSQ: 121,
		FCQLC: 122,
		GC_JDB_SW: 123,
		GC_FC_SW: 124,
		GC_PG_SW: 125,
		GC_HRG_SW: 126,
		GC_CHOICE_SW: 127,
		GC_CR_SW: 128,
		GC_CQ9_SW: 129,
		GC_COMBO_SW: 130,
	},
	ExternalGameCategory: {
		VIDEO_SLOT: 1,
		SPORT: 2,
		CARD: 3,
		FISH: 4,
		ESPORT: 5,
		FINANCIAL: 6,
		LIVE: 7,
		YBGAME: 8,
		BLOCKCHAIN: 9,
		EX_LOTTERY: 10,
		ALL: 999,
	},
	LotteryGameState: {
		ONLINE: 0,
		MAINTAIN: 1,
		OFFLINE: 2,
		OFFCIAL_OFFLINE: 3,
	},
	BetState: {
		BET: 0,
		CANCEL: 1,
		NOPRIZE: 2,
		WIN: 3,
	},
	BlockChainBetStateStr: {
		BET: 'BET',
		NOPRIZE: 'NOPRIZE',
		WIN: 'WIN',
		FAIL: 'FAIL',
		CANCEL: 'CANCEL',
		INVALID: 'INVALID',
		PROCESSING: 'PROCESSING',
		CANCELING: 'CANCELING',
		CANCELFAILED: 'CANCELFAILED',
		REFUNDING: 'REFUNDING',
		REFUNDFAILED: 'REFUNDFAILED',
	},
	ScheduleState: {
		ONGOING: 0,
		DONE: 1,
		CANCELDUETOWIN: 2,
		CANCELDUETOLOSS: 3,
		CANCELDUETOEARN: 4,
	},
	ScheduleBetState: {
		WAITING: 0,
		CANCEL: 1,
		BET: 2,
		CANCELDUETOWIN: 3,
		CANCELDUETOLOSS: 4,
		CANCELDUETOEARN: 5,
	},
	GameType: {
		LOTTERY: 0,
		VRLottery: 1,
		PT: 2,
		AG: 3,
		GG: 4,
		EBET: 5,
		GD: 6,
		MG: 7,
		SA: 8,
		UG: 9,
		YLB: 10,
		PG: 11,
		KY: 12,
		TGP: 13,
		BBin: 14,
		KG: 15,
		DG: 16,
		AVIA: 17,
		JDB: 18,
		BIO: 19,
		AS: 20,
		YC: 21,
		GAMMA: 22,
		CMD: 23,
		CQ9: 24,
		DS: 25,
		VG: 26,
		VRGame: 27,
		FC: 30,
		IM: 31,
		DONGSEN: 32,
		LEG: 33,
		TM: 34,
		YB: 35,
		BBin2: 36,
		SB: 37,
		IBO: 38,
		DREAMWORK: 39,
		CR: 40,
		XBB: 41,
		ROYAL: 42,
		EGP_AG: 43,
		EGP_KY: 44,
		EGP_BBIN: 45,
		EGP_CR: 46,
		EGP_AWC: 47,
		EGP_JDB: 48,
		EGP_CQ9: 49,
		DUEL_LOTTERY: 50,
		GDQ: 51,
		EGP_SB: 52,
		TG: 53,
		ICG: 54,
		EGP_FC: 55,
		WALI: 56,
		CT: 57,
		GR: 58,
		ALLBET: 59,
		BlockChainLottery: 60,
		PP: 61,
		BTI_SW: 62,
		WM: 63,
		IM_SW: 64,
		CR_SW: 65,
		OBSPORT_SW: 66,
		BAISON: 67,
		CG_SW: 68,
		PMLIVE_SW: 69,
		HRG_SW: 70,
		CARD86: 71,
		GC_SW: 72,
		BG: 73,
		WE: 74,
		HRG: 75,
		ZZSIX: 76,
		EGP_LEG: 77,
		SING3: 78,
		TIKI: 79,
		BTI2: 80,
		VRGame_SW: 81,
		DBGAME_SW: 82,
		SPRIBE_SW: 83,
		MWGAMES: 84,
		GC_JDB_SW: 85,
		GC_FC_SW: 86,
		GC_PG_SW: 87,
		GC_HRG_SW: 88,
		GC_CHOICE_SW: 89,
		GC_CR_SW: 90,
		GC_CQ9_SW: 91,
		GC_COMBO_SW: 92,
		BET_POLICY_DENIED_MARKSIX: 901,
		ExternalGameCategory: 1000,
		VIDEO_SLOT: 1001,
		SPORT: 1002,
		CARD: 1003,
		FISH: 1004,
		ESPORT: 1005,
		FINANCIAL: 1006,
		LIVE: 1007,
		YBGAME: 1008,
		BLOCKCHAIN: 1009,
		EX_LOTTERY: 1010,
		EXTERNAL_GAME_SUMMARY: 9999,
	},
	BlockChainGameType: {
		LuckyHash: 1,
		HashDuoDragon: 2,
	},
	CollectionType: {
		GAME: 0,
		BET_INFO: 1,
		GAME_MOBILE: 2,
		FUNCTION: 3,
		FUNCTION_MOBILE: 4,
		DRAW_HISTORY_MOBILE: 5,
		BETTYPE: 6,
		BET_PLAN: 7,
		DRAW_LOBBY: 8,
		EXCLUDEBETTYPE: 9,
	},
	BetMode: {
		GENERAL: 0,
		TEXT: 1,
		BETDOUBLE: 2,
	},
	BetVerificationResult: {
		SUCCESS: 0,
		UNBOUND: 1,
		IP_ADDRESS_DIFFERENT: 2,
		FAIL: 3,
	},
	IssueState: {
		WAITING: 0,
		WINNUMBERGOT: 1,
		AWARDED: 2,
		CANCEL: 3,
	},
	CashType: {
		MONEY: 0,
		GAME_POINT: 1,
	},
	CashFlowType: {
		DEPOSIT: 0,
		THIRDPARTYPAY_DEPOSIT: 1,
		DRAW: 2,
		FIRSTSAVE_BONUS: 3,
		SAVE_BONUS: 4,
		CANCELLED_DRAW: 5,
		DRAW_FEE: 6,
		BANK_DRAW_FEE: 7,
		ELECTRONIC_PURSE_DEPOSIT: 8,
		MANAUALDEPOSIT: 10,
		MANAUALDEPOSITBONUS: 11,
		MANAUALDEPOSITCOMMISSION: 12,
		MANAUALDEPOSITOTHERS: 13,
		MANAUALDEPOSITPATCH: 14,
		MANAUALDEPOSIT_USDT: 15,
		MANAUALWITHDRAW: 20,
		MANAUALWITHDRAWBONUS: 21,
		MANAUALWITHDRAWCOMMISSION: 22,
		MANAUALWITHDRAWOTHERS: 23,
		TRANSFER_DEPOSIT: 30,
		TRANSFER_ACTIVITY: 31,
		TRANSFER_DIVIDEND: 32,
		TRANSFER_WITHDRAW: 33,
		TRANSFER_WITHDRAW_ACTIVITY: 34,
		TRANSFER_WITHDRAW_DIVIDEND: 35,
		TRANSFERDAILYREWARD: 36,
		TRANSFERWITHDRAWDAILYREWARD: 37,
		TRANSFERREDPACKET: 38,
		TRANSFERWITHDRAWREDPACKET: 39,
		TRANSFEROTHER: 40,
		TRANSFERWITHDRAWOTHER: 41,
		TRANSFER_TO_SAFETYBOX: 42,
		TRANSFER_FROM_SAFETYBOX: 43,
		TRANSFER_DAILYPAY: 44,
		TRANSFER_WITHDRAW_DAILYPAY: 45,
		RECYCLEDEPOSIT: 50,
		RECYCLEWITHDRAW: 51,
		RECYCLEBONUS: 52,
		RECYCLECOMMISSION: 53,
		RECYCLEWITHDRAWBONUS: 54,
		RECYCLEWITHDRAWCOMMISSION: 55,
		SELF_OPERATED_RETURN_POINT: 59,
		BET: 60,
		SCHEDULE: 61,
		BET_CANCELLED: 62,
		SCHEDULE_CANCELLED: 63,
		ISSUECANCELLED: 64,
		PRIZE: 65,
		CANCEL_PRIZE: 66,
		RETURNPOINT: 67,
		DESCENTANT_RETURNPOINT: 68,
		EXTERNALGAME_PERIODIC_RETURNPOINT: 69,
		EXTERNALGAME_AUTO_SUPPORT: 70,
		EXTERNALGAME_DAILYPAY: 71,
		EXTERNALGAME_DAILYPAY_RECEIVE: 72,
		EXTERNALGAME_CARD_AUTO_SUPPORT: 73,
		EXTERNALGAME_CARD_DAILYPAY: 74,
		EXTERNALGAME_CARD_DAILYPAY_RECEIVE: 75,
		EXTERNALGAME_WEEK_BONUS: 76,
		EXTERNALGAME_SPORT_WEEK_BONUS: 77,
		EXTERNALGAME_CARD_WEEK_BONUS: 78,
		EXTERNALGAME_FISH_WEEK_BONUS: 79,
		PAY_BETPROPOSAL_COMMISSION: 80,
		RECEIVE_BETPROPOSAL_COMMISSION: 81,
		BETCOMMISSION: 82,
		CANCEL_BETCOMMISSION: 83,
		LOSSCOMMISSION: 84,
		CANCEL_LOSSCOMMISSION: 85,
		DIRECT_AGENT_BETCOMMISSION: 86,
		CANCEL_DIRECT_AGENT_BETCOMMISSION: 87,
		DIRECT_AGENT_LOSSCOMMISSION: 88,
		CANCEL_DIRECT_AGENT_LOSSCOMMISSION: 89,
		MEMBER_BETCOMMISSION: 90,
		CANCEL_MEMBER_BETCOMMISSION: 91,
		MEMBER_LOSSCOMMISSION: 92,
		CANCEL_MEMBER_LOSSCOMMISSION: 93,
		EXTERNALGAMECOMMISSION: 94,
		CANCELEXTERNALGAMECOMMISSION: 95,
		DIVIDEND: 96,
		DIVIDENDRECEIVE: 97,
		ACCOUNTSECURITYBONUS: 98,
		ACTIVITYBONUS: 99,
		WECHAT_REGISTERATION_BONUS: 100,
		WECHAT_BET_BONUS: 101,
		AGENT_ACTIVITY_PAY: 102,
		AGENT_ACTIVITY_RETURN: 103,
		EXTERNAL_CHAT_DONATE: 104,
		DAILYPAY_RETURNPOINT: 105,
		AUTOBONUS: 106,
		AGENT_AUTOSUPPORT: 107,
		DAILYPAY: 108,
		DAILYPAY_RECEIVE: 109,
		LOGIN_INCENTIVE: 110,
		PERSONAL_DAILY_TASK_INCENTIVE: 111,
		EXTRA_INCENTIVE: 112,
		CONSUME_INCENTIVE: 113,
		DEPOSIT_INCENTIVE: 114,
		REDEEM_VOUCGER_ACTIVITY_WINNING: 115,
		REDEEM_VOUCHER_ACTIVITY_CASHPURCHASE: 116,
		SVIP_ACTIVITY: 117,
		COUPON_DEPOSIT_BONUS: 118,
		COUPON_ACTIVITY_BONUS: 119,
		CONTINUOUS_SIGN_BONUS: 120,
		CONTINUOUS_BET: 121,
		VR_LOTTERY_RETURN_POINT: 122,
		DESCENTANT_VR_LOTTERY_RETURN_POINT: 123,
		NON_SELF_OPERATED_RETURN_POINT: 124,
		SELF_OPERATED_DAILY_RETURN_POINT: 125,
		NON_SELF_OPERATED_DAILY_RETURN_POINT: 126,
		REGULAR_PAY: 127,
		COMMISSION: 128,
		EXTERNALGAME_AGENT_AG_AUTOSUPPORT: 129,
		EXTERNALGAME_AGENT_KY_AUTOSUPPORT: 130,
		REGISTER_ACTIVITY: 131,
		VCP_DEPOSIT: 132,
		VCP_WITHDRAW: 133,
		LOSE_PAY: 134,
		VCP_CANCELED_DRAW: 135,
		BET_FEE: 136,
		AGENT_SERVICE_FEE: 137,
		AGENT_SERVICE_FEE_COST: 138,
		DUEL_RETURNPOINT: 139,
		AGENT_DEPOSIT_BONUS_ACTIVITY: 140,
		DIRECTAGENT_DEPOSIT_BONUS_ACTIVITY: 141,
		AGENT_WITHDRAW_BONUS_ACTIVITY: 142,
		DIRECTAGENT_WITHDRAW_BONUS_ACTIVITY: 143,
		LOSE_PAY_VR: 144,
		DUEL_BET: 145,
		DUEL_PRIZE: 146,
		DEPOSIT_COMMISSION_BONUS: 147,
		REAL_TIME_PAY: 148,
		AUTOBONUS_IMMEDIATE_DESCENDANT: 149,
		VIPDEPOSIT_ACTIVITY: 150,
		DUEL_ACTIVITY: 151,
		NO_USE: 152,
		EXTERNALGAME_SPORT_DAILYPAY_RECEIVE: 153,
		VIP_RETURN_POINT: 154,
		VIP_LEVEL_UP_BONUS: 155,
		VIP_WEEKLY_BONUS: 156,
		DEPOSIT_REBATE: 157,
		EXTERNALGAME_AUTOBONUS: 158,
		PROPORTIONAL_MARIN: 159,
		RETURN_PROPORTIONAL_MARIN: 160,
		PROPORTIONAL_BONUS: 161,
		PROPORTIONAL_MINUS_BONUS: 162,
		CG_REGULARPAY_RECEIVE: 163,
		DIRECT_AGENT_DEDUCT_DEPOSIT_FEE: 164,
		DEPOSIT_BY_CATEGORY_ACTIVITY: 165,
		ELECTRONIC_PURSE_DRAW: 166,
		ELECTRONIC_PURSE_CANCELED_DRAW: 167,
		DEPOSIT_BONUS: 168,
		RECOMMEND_FRIEND_REBATE: 169,
		SHARE_HOLDER_BONUS: 170,
		SHARE_HOLDER_BONUS_EXTERNAL: 171,
		COUPON_AGENT_DEDUCTIONS: 172,
		AUTOBONUS_HIDDEN: 173,
		DAILY_TREASURE_CHEST_MISSION_ACTIVITY: 174,
		RELIEFPACKAGE_ACTIVITY: 175,
		DAILY_INTEREST: 512,
		AWARD_SERVICE_FEE_COST: 513,
		PLATFORM_SERVICE_FEE: 514,
		PLATFORM_SERVICE_FEE_COST: 515,
		AGENT_SERVICE_FEE_REFUND: 516,
		BET_FEE_REFUND: 517,
		LION_KING_CONTEST_COMMISSION_RECEIVE: 518,
		LION_KING_CONTEST_COMMISSION_PAY: 519,
		RETURNPOINT_REFUND: 520,
		DESCENTANT_RETURNPOINT_REFUND: 521,
		AWARD_SERVICE_FEE_COST_REFUND: 522,
		PLATFORM_SERVICE_FEE_COST_REFUND: 523,
		RETURNPOINT_PAY: 524,
		VR_LOTTERY_RETURN_POINT_PAY: 525,
		RETURNPOINT_PAY_REFUND: 526,
		VR_AGENT_SERVICE_FEE: 527,
		VR_AGENT_SERVICE_FEE_COST: 528,
		LOTTERY_TRANS_TO_AG: 1000,
		AG_TRANS_TO_LOTTERY: 1001,
		AG_RETURN_POINT: 1002,
		DESCENTANT_AG_RETURN_POINT: 1003,
		LOTTERY_TRANS_TO_GD: 1004,
		GD_TRANS_TO_LOTTERY: 1005,
		GD_RETURN_POINT: 1006,
		DESCENTANT_GD_RETURN_POINT: 1007,
		LOTTERY_TRANS_TO_MG: 1008,
		MG_TRANS_TO_LOTTERY: 1009,
		MG_RETURN_POINT: 1010,
		DESCENTANT_MG_RETURN_POINT: 1011,
		LOTTERY_TRANS_TO_SA: 1012,
		SA_TRANS_TO_LOTTERY: 1013,
		SA_RETURN_POINT: 1014,
		DESCENTANT_SA_RETURN_POINT: 1015,
		LOTTERY_TRANS_TO_UG: 1016,
		UG_TRANS_TO_LOTTERY: 1017,
		UG_RETURN_POINT: 1018,
		DESCENTANT_UG_RETURN_POINT: 1019,
		LOTTERY_TRANS_TO_YLB: 1020,
		YLB_TRANS_TO_LOTTERY: 1021,
		YLB_RETURN_POINT: 1022,
		DESCENTANT_YLB_RETURN_POINT: 1023,
		LOTTERY_TRANS_TO_PG: 1024,
		PG_TRANS_TO_LOTTERY: 1025,
		PG_RETURN_POINT: 1026,
		DESCENTANT_PG_RETURN_POINT: 1027,
		LOTTERY_TRANS_TO_KY: 1028,
		KY_TRANS_TO_LOTTERY: 1029,
		KY_RETURN_POINT: 1030,
		DESCENTANT_KY_RETURN_POINT: 1031,
		LOTTERY_TRANS_TO_TGP: 1032,
		TGP_TRANS_TO_LOTTERY: 1033,
		TGP_RETURN_POINT: 1034,
		DESCENTANT_TGP_RETURN_POINT: 1035,
		LOTTERY_TRANS_TO_GR: 1036,
		GR_TRANS_TO_LOTTERY: 1037,
		GR_RETURN_POINT: 1038,
		DESCENTANT_GR_RETURN_POINT: 1039,
		LOTTERY_TRANS_TO_KG: 1040,
		KG_TRANS_TO_LOTTERY: 1041,
		KG_RETURN_POINT: 1042,
		DESCENTANT_KG_RETURN_POINT: 1043,
		LOTTERY_TRANS_TO_DG: 1044,
		DG_TRANS_TO_LOTTERY: 1045,
		DG_RETURN_POINT: 1046,
		DESCENTANT_DG_RETURN_POINT: 1047,
		LOTTERY_TRANS_TO_AVIA: 1048,
		AVIA_TRANS_TO_LOTTERY: 1049,
		AVIA_RETURN_POINT: 1050,
		DESCENTANT_AVIA_RETURN_POINT: 1051,
		LOTTERY_TRANS_TO_JDB: 1052,
		JDB_TRANS_TO_LOTTERY: 1053,
		JDB_RETURN_POINT: 1054,
		DESCENTANT_JDB_RETURN_POINT: 1055,
		LOTTERY_TRANS_TO_BIO: 1056,
		BIO_TRANS_TO_LOTTERY: 1057,
		BIO_RETURN_POINT: 1058,
		DESCENTANT_BIO_RETURN_POINT: 1059,
		LOTTERY_TRANS_TO_AS: 1060,
		AS_TRANS_TO_LOTTERY: 1061,
		AS_RETURN_POINT: 1062,
		DESCENTANT_AS_RETURN_POINT: 1063,
		LOTTERY_TRANS_TO_CT: 1064,
		CT_TRANS_TO_LOTTERY: 1065,
		CT_RETURN_POINT: 1066,
		DESCENTANT_CT_RETURN_POINT: 1067,
		LOTTERY_TRANS_TO_GAMMA: 1068,
		GAMMA_TRANS_TO_LOTTERY: 1069,
		GAMMA_RETURN_POINT: 1070,
		DESCENTANT_GAMMA_RETURN_POINT: 1071,
		LOTTERY_TRANS_TO_TM: 1072,
		TM_TRANS_TO_LOTTERY: 1073,
		TM_RETURN_POINT: 1074,
		DESCENTANT_TM_RETURN_POINT: 1075,
		LOTTERY_TRANS_TO_CMD: 1076,
		CMD_TRANS_TO_LOTTERY: 1077,
		CMD_RETURN_POINT: 1078,
		DESCENTANT_CMD_RETURN_POINT: 1079,
		LOTTERY_TRANS_TO_CQ9: 1080,
		CQ9_TRANS_TO_LOTTERY: 1081,
		CQ9_RETURN_POINT: 1082,
		DESCENTANT_CQ9_RETURN_POINT: 1083,
		LOTTERY_TRANS_TO_DS: 1084,
		DS_TRANS_TO_LOTTERY: 1085,
		DS_RETURN_POINT: 1086,
		DESCENTANT_DS_RETURN_POINT: 1087,
		LOTTERY_TRANS_TO_VG: 1088,
		VG_TRANS_TO_LOTTERY: 1089,
		VG_RETURN_POINT: 1090,
		DESCENTANT_VG_RETURN_POINT: 1091,
		LOTTERY_TRANS_TO_PT: 1092,
		PT_TRANS_TO_LOTTERY: 1093,
		PT_RETURN_POINT: 1094,
		DESCENTANT_PT_RETURN_POINT: 1095,
		LOTTERY_TRANS_TO_GG: 1096,
		GG_TRANS_TO_LOTTERY: 1097,
		GG_RETURN_POINT: 1098,
		DESCENTANT_GG_RETURN_POINT: 1099,
		LOTTERY_TRANS_TO_EBET: 1100,
		EBET_TRANS_TO_LOTTERY: 1101,
		EBET_RETURN_POINT: 1102,
		DESCENTANT_EBET_RETURN_POINT: 1103,
		LOTTERY_TRANS_TO_VR: 1104,
		VR_TRANS_TO_LOTTERY: 1105,
		VR_GAME_RETURN_POINT: 1106,
		DESCENTANT_VR_GAME_RETURN_POINT: 1107,
		LOTTERY_TRANS_TO_WALI: 1108,
		WALI_TRANS_TO_LOTTERY: 1109,
		WALI_RETURN_POINT: 1110,
		DESCENTANT_WALI_RETURN_POINT: 1111,
		LOTTERY_TRANS_TO_TG: 1112,
		TG_TRANS_TO_LOTTERY: 1113,
		TG_RETURN_POINT: 1114,
		DESCENTANT_TG_RETURN_POINT: 1115,
		LOTTERY_TRANS_TO_FC: 1116,
		FC_TRANS_TO_LOTTERY: 1117,
		FC_RETURN_POINT: 1118,
		DESCENTANT_FC_RETURN_POINT: 1119,
		LOTTERY_TRANS_TO_IM: 1120,
		IM_TRANS_TO_LOTTERY: 1121,
		IM_RETURN_POINT: 1122,
		DESCENTANT_IM_RETURN_POINT: 1123,
		LOTTERY_TRANS_TO_DONGSEN: 1124,
		DONGSEN_TRANS_TO_LOTTERY: 1125,
		DONGSEN_RETURN_POINT: 1126,
		DESCENTANT_DONGSEN_RETURN_POINT: 1127,
		LOTTERY_TRANS_TO_LEG: 1128,
		LEG_TRANS_TO_LOTTERY: 1129,
		LEG_RETURN_POINT: 1130,
		DESCENTANT_LEG_RETURN_POINT: 1131,
		LOTTERY_TRANS_TO_ALLBET: 1132,
		ALLBET_TRANS_TO_LOTTERY: 1133,
		ALLBET_RETURN_POINT: 1134,
		DESCENTANT_ALLBET_RETURN_POINT: 1135,
		LOTTERY_TRANS_TO_BBIN2: 1136,
		BBIN2_TRANS_TO_LOTTERY: 1137,
		BBIN2_RETURN_POINT: 1138,
		DESCENTANT_BBIN2_RETURN_POINT: 1139,
		LOTTERY_TRANS_TO_SB: 1140,
		SB_TRANS_TO_LOTTERY: 1141,
		SB_RETURN_POINT: 1142,
		DESCENTANT_SB_RETURN_POINT: 1143,
		LOTTERY_TRANS_TO_IBO: 1144,
		IBO_TRANS_TO_LOTTERY: 1145,
		IBO_RETURN_POINT: 1146,
		DESCENTANT_IBO_RETURN_POINT: 1147,
		LOTTERY_TRANS_TO_DREAMWORK: 1148,
		DREAMWORK_TRANS_TO_LOTTERY: 1149,
		DREAMWORK_RETURN_POINT: 1150,
		DESCENTANT_DREAMWORK_RETURN_POINT: 1151,
		LOTTERY_TRANS_TO_CR: 1152,
		CR_TRANS_TO_LOTTERY: 1153,
		CR_RETURN_POINT: 1154,
		DESCENTANT_CR_RETURN_POINT: 1155,
		LOTTERY_TRANS_TO_XBB: 1156,
		XBB_TRANS_TO_LOTTERY: 1157,
		XBB_RETURN_POINT: 1158,
		DESCENTANT_XBB_RETURN_POINT: 1159,
		LOTTERY_TRANS_TO_EGP_AG: 1160,
		EGP_AG_TRANS_TO_LOTTERY: 1161,
		EGP_AG_RETURN_POINT: 1162,
		DESCENTANT_EGP_AG_RETURN_POINT: 1163,
		LOTTERY_TRANS_TO_EGP_KY: 1164,
		EGP_KY_TRANS_TO_LOTTERY: 1165,
		EGP_KY_RETURN_POINT: 1166,
		DESCENTANT_EGP_KY_RETURN_POINT: 1167,
		LOTTERY_TRANS_TO_EGP_BBIN: 1168,
		EGP_BBIN_TRANS_TO_LOTTERY: 1169,
		EGP_BBIN_RETURN_POINT: 1170,
		DESCENTANT_EGP_BBIN_RETURN_POINT: 1171,
		LOTTERY_TRANS_TO_EGP_CR: 1172,
		EGP_CR_TRANS_TO_LOTTERY: 1173,
		EGP_CR_RETURN_POINT: 1174,
		DESCENTANT_EGP_CR_RETURN_POINT: 1175,
		LOTTERY_TRANS_TO_EGP_AWC: 1176,
		EGP_AWC_TRANS_TO_LOTTERY: 1177,
		EGP_AWC_RETURN_POINT: 1178,
		DESCENTANT_EGP_AWC_RETURN_POINT: 1179,
		LOTTERY_TRANS_TO_EGP_JDB: 1180,
		EGP_JDB_TRANS_TO_LOTTERY: 1181,
		EGP_JDB_RETURN_POINT: 1182,
		DESCENTANT_EGP_JDB_RETURN_POINT: 1183,
		LOTTERY_TRANS_TO_EGP_CQ9: 1184,
		EGP_CQ9_TRANS_TO_LOTTERY: 1185,
		EGP_CQ9_RETURN_POINT: 1186,
		DESCENTANT_EGP_CQ9_RETURN_POINT: 1187,
		LOTTERY_TRANS_TO_GDQ: 1188,
		GDQ_TRANS_TO_LOTTERY: 1189,
		GDQ_RETURN_POINT: 1190,
		DESCENTANT_GDQ_RETURN_POINT: 1191,
		LOTTERY_TRANS_TO_EGP_SB: 1192,
		EGP_SB_TRANS_TO_LOTTERY: 1193,
		EGP_SB_RETURN_POINT: 1194,
		DESCENTANT_EGP_SB_RETURN_POINT: 1195,
		LOTTERY_TRANS_TO_ICG: 1196,
		ICG_TRANS_TO_LOTTERY: 1197,
		ICG_RETURN_POINT: 1198,
		DESCENTANT_ICG_RETURN_POINT: 1199,
		LOTTERY_TRANS_TO_EGP_FC: 1200,
		EGP_FC_TRANS_TO_LOTTERY: 1201,
		EGP_FC_RETURN_POINT: 1202,
		DESCENTANT_EGP_FC_RETURN_POINT: 1203,
		LOTTERY_TRANS_TO_PP: 1204,
		PP_TRANS_TO_LOTTERY: 1205,
		PP_RETURN_POINT: 1206,
		DESCENTANT_PP_RETURN_POINT: 1207,
		LOTTERY_TRANS_TO_BTI: 1208,
		BTI_TRANS_TO_LOTTERY: 1209,
		BTI_RETURN_POINT: 1210,
		DESCENTANT_BTI_RETURN_POINT: 1211,
		LOTTERY_TRANS_TO_WM: 1212,
		WM_TRANS_TO_LOTTERY: 1213,
		WM_RETURN_POINT: 1214,
		DESCENTANT_WM_RETURN_POINT: 1215,
		LOTTERY_TRANS_TO_IM_SW: 1216,
		IM_SW_TRANS_TO_LOTTERY: 1217,
		IM_SW_RETURN_POINT: 1218,
		DESCENTANT_IM_SW_RETURN_POINT: 1219,
		LOTTERY_TRANS_TO_OBSPORT_SW: 1220,
		OBSPORT_SW_TRANS_TO_LOTTERY: 1221,
		OBSPORT_SW_RETURN_POINT: 1222,
		DESCENTANT_OBSPORT_SW_RETURN_POINT: 1223,
		LOTTERY_TRANS_TO_BAISON: 1224,
		BAISON_TRANS_TO_LOTTERY: 1225,
		BAISON_RETURN_POINT: 1226,
		DESCENTANT_BAISON_RETURN_POINT: 1227,
		LOTTERY_TRANS_TO_CG_SW: 1228,
		CG_SW_TRANS_TO_LOTTERY: 1229,
		CG_SW_RETURN_POINT: 1230,
		DESCENTANT_CG_SW_RETURN_POINT: 1231,
		LOTTERY_TRANS_TO_PMLIVE_SW: 1232,
		PMLIVE_SW_TRANS_TO_LOTTERY: 1233,
		PMLIVE_SW_RETURN_POINT: 1234,
		DESCENTANT_PMLIVE_SW_RETURN_POINT: 1235,
		LOTTERY_TRANS_TO_HRG_SW: 1236,
		HRG_SW_TRANS_TO_LOTTERY: 1237,
		HRG_SW_RETURN_POINT: 1238,
		DESCENTANT_HRG_SW_RETURN_POINT: 1239,
		LOTTERY_TRANS_TO_CARD86: 1240,
		CARD86_TRANS_TO_LOTTERY: 1241,
		CARD86_RETURN_POINT: 1242,
		DESCENTANT_CARD86_RETURN_POINT: 1243,
		LOTTERY_TRANS_TO_GC_SW: 1244,
		GC_SW_TRANS_TO_LOTTERY: 1245,
		GC_SW_RETURN_POINT: 1246,
		DESCENTANT_GC_SW_RETURN_POINT: 1247,
		LOTTERY_TRANS_TO_BG: 1248,
		BG_TRANS_TO_LOTTERY: 1249,
		BG_RETURN_POINT: 1250,
		DESCENTANT_BG_RETURN_POINT: 1251,
		LOTTERY_TRANS_TO_WE: 1252,
		WE_TRANS_TO_LOTTERY: 1253,
		WE_RETURN_POINT: 1254,
		DESCENTANT_WE_RETURN_POINT: 1255,
		LOTTERY_TRANS_TO_HRG: 1256,
		HRG_TRANS_TO_LOTTERY: 1257,
		HRG_RETURN_POINT: 1258,
		DESCENTANT_HRG_RETURN_POINT: 1259,
		LOTTERY_TRANS_TO_ZZSIX: 1260,
		ZZSIX_TRANS_TO_LOTTERY: 1261,
		ZZSIX_RETURN_POINT: 1262,
		DESCENTANT_ZZSIX_RETURN_POINT: 1263,
		LOTTERY_TRANS_TO_EGPLEG: 1264,
		EGPLEG_TRANS_TO_LOTTERY: 1265,
		EGPLEG_RETURN_POINT: 1266,
		DESCENTANT_EGPLEG_RETURN_POINT: 1267,
		LOTTERY_TRANS_TO_SING3: 1268,
		SING3_TRANS_TO_LOTTERY: 1269,
		SING3_RETURN_POINT: 1270,
		DESCENTANT_SING3_RETURN_POINT: 1271,
		LOTTERY_TRANS_TO_TIKI: 1272,
		TIKI_TRANS_TO_LOTTERY: 1273,
		TIKI_RETURN_POINT: 1274,
		DESCENTANT_TIKI_RETURN_POINT: 1275,
		LOTTERY_TRANS_TO_BTI2: 1276,
		BTI2_TRANS_TO_LOTTERY: 1277,
		BTI2_RETURN_POINT: 1278,
		DESCENTANT_BTI2_RETURN_POINT: 1279,
		LOTTERY_TRANS_TO_VRGame_SW: 1280,
		VRGame_SW_TRANS_TO_LOTTERY: 1281,
		VRGame_SW_RETURN_POINT: 1282,
		DESCENTANT_VRGame_SW_RETURN_POINT: 1283,
		LOTTERY_TRANS_TO_DBGAME_SW: 1284,
		DBGAME_SW_TRANS_TO_LOTTERY: 1285,
		DBGAME_SW_RETURN_POINT: 1286,
		DESCENTANT_DBGAME_SW_RETURN_POINT: 1287,
		LOTTERY_TRANS_TO_SPRIBE_SW: 1288,
		SPRIBE_SW_TRANS_TO_LOTTERY: 1289,
		SPRIBE_SW_RETURN_POINT: 1290,
		DESCENTANT_SPRIBE_SW_RETURN_POINT: 1291,
		LOTTERY_TRANS_TO_MWGAMES: 1292,
		MWGAMES_TRANS_TO_LOTTERY: 1293,
		MWGAMES_RETURN_POINT: 1294,
		DESCENTANT_MWGAMES_RETURN_POINT: 1295,
		LOTTERY_TRANS_TO_GC_JDB_SW: 1296,
		GC_JDB_SW_TRANS_TO_LOTTERY: 1297,
		GC_JDB_SW_RETURN_POINT: 1298,
		DESCENTANT_GC_JDB_SW_RETURN_POINT: 1299,
		LOTTERY_TRANS_TO_GC_FC_SW: 1300,
		GC_FC_SW_TRANS_TO_LOTTERY: 1301,
		GC_FC_SW_RETURN_POINT: 1302,
		DESCENTANT_GC_FC_SW_RETURN_POINT: 1303,
		LOTTERY_TRANS_TO_GC_PG_SW: 1304,
		GC_PG_SW_TRANS_TO_LOTTERY: 1305,
		GC_PG_SW_RETURN_POINT: 1306,
		DESCENTANT_GC_PG_SW_RETURN_POINT: 1307,
		LOTTERY_TRANS_TO_GC_HRG_SW: 1308,
		GC_HRG_SW_TRANS_TO_LOTTERY: 1309,
		GC_HRG_SW_RETURN_POINT: 1310,
		DESCENTANT_GC_HRG_SW_RETURN_POINT: 1311,
		LOTTERY_TRANS_TO_GC_CHOICE_SW: 1312,
		GC_CHOICE_SW_TRANS_TO_LOTTERY: 1313,
		GC_CHOICE_SW_RETURN_POINT: 1314,
		DESCENTANT_GC_CHOICE_SW_RETURN_POINT: 1315,
		LOTTERY_TRANS_TO_GC_CR_SW: 1316,
		GC_CR_SW_TRANS_TO_LOTTERY: 1317,
		GC_CR_SW_RETURN_POINT: 1318,
		DESCENTANT_GC_CR_SW_RETURN_POINT: 1319,
		LOTTERY_TRANS_TO_GC_CQ9_SW: 1320,
		GC_CQ9_SW_TRANS_TO_LOTTERY: 1321,
		GC_CQ9_SW_RETURN_POINT: 1322,
		DESCENTANT_GC_CQ9_SW_RETURN_POINT: 1323,
		LOTTERY_TRANS_TO_GC_COMBO_SW: 1324,
		GC_COMBO_SW_TRANS_TO_LOTTERY: 1325,
		GC_COMBO_SW_RETURN_POINT: 1326,
		DESCENTANT_GC_COMBO_SW_RETURN_POINT: 1327,
		EXTERNAL_GAME_DEBIT: 2000,
		BTI_EXTERNAL_GAME_DEBIT: 2001,
		IM_EXTERNAL_GAME_DEBIT: 2002,
		CR_EXTERNAL_GAME_DEBIT: 2003,
		OBSPORT_EXTERNAL_GAME_DEBIT: 2004,
		CG_EXTERNAL_GAME_DEBIT: 2005,
		PMLIVE_EXTERNAL_GAME_DEBIT: 2006,
		HRG_EXTERNAL_GAME_DEBIT: 2007,
		GC_EXTERNAL_GAME_DEBIT: 2008,
		VRGame_EXTERNAL_GAME_DEBIT: 2009,
		DBGAME_EXTERNAL_GAME_DEBIT: 2010,
		SPRIBE_EXTERNAL_GAME_DEBIT: 2011,
		GC_JDB_EXTERNAL_GAME_DEBIT: 2012,
		GC_FC_EXTERNAL_GAME_DEBIT: 2013,
		GC_PG_EXTERNAL_GAME_DEBIT: 2014,
		GC_HRG_EXTERNAL_GAME_DEBIT: 2015,
		GC_CHOICE_EXTERNAL_GAME_DEBIT: 2016,
		GC_CR_EXTERNAL_GAME_DEBIT: 2017,
		GC_CQ9_EXTERNAL_GAME_DEBIT: 2018,
		GC_COMBO_EXTERNAL_GAME_DEBIT: 2019,
		EXTERNAL_GAME_REFUND: 2200,
		BTI_EXTERNAL_GAME_REFUND: 2201,
		IM_EXTERNAL_GAME_REFUND: 2202,
		CR_EXTERNAL_GAME_REFUND: 2203,
		OBSPORT_EXTERNAL_GAME_REFUND: 2204,
		CG_EXTERNAL_GAME_REFUND: 2205,
		PMLIVE_EXTERNAL_GAME_REFUND: 2206,
		HRG_EXTERNAL_GAME_REFUND: 2207,
		GC_EXTERNAL_GAME_REFUND: 2208,
		VRGame_EXTERNAL_GAME_REFUND: 2209,
		DBGAME_EXTERNAL_GAME_REFUND: 2210,
		SPRIBE_EXTERNAL_GAME_REFUND: 2211,
		GC_JDB_EXTERNAL_GAME_REFUND: 2212,
		GC_FC_EXTERNAL_GAME_REFUND: 2213,
		GC_PG_EXTERNAL_GAME_REFUND: 2214,
		GC_HRG_EXTERNAL_GAME_REFUND: 2215,
		GC_CHOICE_EXTERNAL_GAME_REFUND: 2216,
		GC_CR_EXTERNAL_GAME_REFUND: 2217,
		GC_CQ9_EXTERNAL_GAME_REFUND: 2218,
		GC_COMBO_EXTERNAL_GAME_REFUND: 2219,
		EXTERNAL_GAME_PRIZE: 2400,
		BTI_EXTERNAL_GAME_PRIZE: 2401,
		IM_EXTERNAL_GAME_PRIZE: 2402,
		CR_EXTERNAL_GAME_PRIZE: 2403,
		OBSPORT_EXTERNAL_GAME_PRIZE: 2404,
		CG_EXTERNAL_GAME_PRIZE: 2405,
		PMLIVE_EXTERNAL_GAME_PRIZE: 2406,
		HRG_EXTERNAL_GAME_PRIZE: 2407,
		GC_EXTERNAL_GAME_PRIZE: 2408,
		VRGame_EXTERNAL_GAME_PRIZE: 2409,
		DBGAME_EXTERNAL_GAME_PRIZE: 2410,
		SPRIBE_EXTERNAL_GAME_PRIZE: 2411,
		GC_JDB_EXTERNAL_GAME_PRIZE: 2412,
		GC_FC_EXTERNAL_GAME_PRIZE: 2413,
		GC_PG_EXTERNAL_GAME_PRIZE: 2414,
		GC_HRG_EXTERNAL_GAME_PRIZE: 2415,
		GC_CHOICE_EXTERNAL_GAME_PRIZE: 2416,
		GC_CR_EXTERNAL_GAME_PRIZE: 2417,
		GC_CQ9_EXTERNAL_GAME_PRIZE: 2418,
		GC_COMBO_EXTERNAL_GAME_PRIZE: 2419,
		EXTERNAL_GAME_ACTIVITY: 2600,
		BTI_EXTERNAL_GAME_ACTIVITY: 2601,
		IM_EXTERNAL_GAME_ACTIVITY: 2602,
		CR_EXTERNAL_GAME_ACTIVITY: 2603,
		OBSPORT_EXTERNAL_GAME_ACTIVITY: 2604,
		CG_EXTERNAL_GAME_ACTIVITY: 2605,
		PMLIVE_EXTERNAL_GAME_ACTIVITY: 2606,
		HRG_EXTERNAL_GAME_ACTIVITY: 2607,
		GC_EXTERNAL_GAME_ACTIVITY: 2608,
		VRGame_EXTERNAL_GAME_ACTIVITY: 2609,
		DBGAME_EXTERNAL_GAME_ACTIVITY: 2610,
		SPRIBE_EXTERNAL_GAME_ACTIVITY: 2611,
		GC_JDB_EXTERNAL_GAME_ACTIVITY: 2612,
		GC_FC_EXTERNAL_GAME_ACTIVITY: 2613,
		GC_PG_EXTERNAL_GAME_ACTIVITY: 2614,
		GC_HRG_EXTERNAL_GAME_ACTIVITY: 2615,
		GC_CHOICE_EXTERNAL_GAME_ACTIVITY: 2616,
		GC_CR_EXTERNAL_GAME_ACTIVITY: 2617,
		GC_CQ9_EXTERNAL_GAME_ACTIVITY: 2618,
		GC_COMBO_EXTERNAL_GAME_ACTIVITY: 2619,
	},
	CashFlowClassification: {
		NONE: 0,
		DEPOSIT: 1,
		DRAW: 2,
		BET: 3,
		BET_CANCELLED: 4,
		PRIZE: 5,
		RETURN_POINT: 6,
		ACTIVITY: 7,
		BONUS: 8,
		TRANSFER_TO_LOTTERY: 9,
		TRANSFER_TO_EXTERNAL: 10,
		DRAW_FEE: 11,
		OTHERS: 12,
		EXTERNAL_RETURN_POINT: 13,
		EXTERNAL_ACTIVITY: 14,
		BET_FEE: 15,
		DUEL_RETURN_POINT: 16,
		DEPOSIT_FEE_BONUS_REQUEST_ACTIVITY: 17,
		WITHDRAW_FEE_BONUS_REQUEST_ACTIVITY: 18,
		EXTERNAL_GAME_DEBIT: 19,
		EXTERNAL_GAME_REFUND: 20,
		EXTERNAL_GAME_PRIZE: 21,
		EXTERNAL_GAME_ACTIVITY: 22,
	},
	CashFlowClassificationStr: {
		NONE: '未分类',
		DEPOSIT: '充值',
		DRAW: '提现',
		BET: '投注',
		BET_CANCELLED: '撤单',
		PRIZE: '奖金',
		RETURN_POINT: '返点',
		ACTIVITY: '活动',
		BONUS: '红利',
		TRANSFER_TO_LOTTERY: '转出',
		TRANSFER_TO_EXTERNAL: '转入',
		DRAW_FEE: '提现手续费',
		OTHERS: '其它',
		EXTERNAL_RETURN_POINT: '外接返点',
		EXTERNAL_ACTIVITY: '外接活动',
		BET_FEE: '投注服务费',
		DUEL_RETURN_POINT: '竞技彩票返点',
		DEPOSIT_FEE_BONUS_REQUEST_ACTIVITY: '充值手续费返还',
		WITHDRAW_FEE_BONUS_REQUEST_ACTIVITY: '提款手续费返还',
		EXTERNAL_GAME_DEBIT: '外接游戏扣款',
		EXTERNAL_GAME_REFUND: '外接游戏退款',
		EXTERNAL_GAME_PRIZE: '外接游戏奖金',
		EXTERNAL_GAME_ACTIVITY: '外接游戏活动',
	},
	RecordType: {
		BETRECORD: 1,
		SCHEDULERECORD: 2,
		CASHFLOWRECORD: 3,
		BETPROPOSAL: 4,
	},
	WithdrawAndDepositRecordType: {
		ALL: 0,
		DEPOSIT: 1,
		WITHDRAW: 2,
		USDT_DEPOSIT: 3,
		USDT_WITHDRAW: 4,
		EP_DEPOSIT: 5,
		EP_WITHDRAW: 6,
	},
	ExternalGameTransType: {
		ALL: 0,
		DEPOSIT: 1,
		DISPENSING: 2,
	},
	ExternalGameTransState: {
		PENDING: 0,
		SUCCESS: 1,
		FAIL: 2,
		CREATE: 3,
	},
	ExternalGameTransTarget: {
		USER_WALLET: 0,
		SAFETY_BOX: 1,
	},
	SafetyBoxTransType: {
		TRANS_IN: 1,
		TRANS_OUT: 2,
	},
	ActivityType: {
		DailySignInActivity: 1,
		DailySigninRedPackActivity: 2,
		DailySignIn2Activity: 3,
		DepositActivity: 100,
		DepositPrizePercentageActivity: 101,
		DepositRedPackActivity: 102,
		DepositByCategoryActivity: 103,
		ConsumeActivity: 200,
		ConsumeByGameActivity: 201,
		VIPActivity: 800,
		TreasureActivity: 801,
		RouletteActivity: 802,
		NewbieQuestActivity: 803,
		DailyTreasureChestMissionActivity: 804,
		ReliefPackageActivity: 805,
		DepositConsumeActivity: 900,
		FirstDepositByCategoryActivity: 901,
		DepositConsumeKENO2Activity: 902,
		ArtificialActivity: 1000,
		AttachedActivity: 1001,
		OneDollarActivity: 1002,
		RedPacketSolitaire: 1003,
		CustomActivity: 1004,
		LuckyDrawActivity: 1005,
		TeamActivity: 2000,
		TeamRedPackRainActivity: 2001,
		TeamConsumeActivity: 2002,
		TeamDepositActivity: 2003,
		TeamLossActivity: 2004,
	},
	ActivityRepeatable: {
		ONCE_PER_DAY: 0,
		ONCE_DURING_ACTIVITY: 1,
		UNLIMITED_PER_DAY: 2,
	},
	AgentActivityRecordType: {
		REDPACK_PLAYER_SEND: 0,
		REDPACK_PLAYER_RECIVED: 1,
		REDPACK_SINGLE_RECIVED: 2,
	},
	DepositByCategoryActivityCategoryStr: {
		Bank: 'Bank',
		ThirdParty: 'ThirdParty',
		USDT: 'USDT',
	},
	BetRequiredItem: {
		ACTIVITY_BONUS: 0,
		DEPOSIT_AMOUNT: 1,
		DEPOSIT_AND_BONUS_AMOUNT: 2,
	},
	ActivityResult: {
		SUCCESS: 0,
		FAILED: 1,
		CONDITION_DELETE_ERROR: 2,
		UPLOAD_IMAGE_FAILED: 3,
		INVALID_PARAMS: 4,
		ACTIVITY_NOT_FOUND: 5,
		DESCENDANTS_NOT_FOUND: 6,
		FREQUENT_EXECUTION: 7,
		UPDATE_WALLET_ERROR: 8,
		NOT_ENOUGH_MONEY: 9,
		INVALID_DRAWPASSWORD: 10,
		WRONG_DRAWPASSWORD: 11,
		INVALID_GOOGLE_AUTH_PASSWORD: 12,
		DIVIDEND_CONTRACT_LIMIT: 13,
		DAILY_PAY_LIMIT: 14,
		ENABLE_TRANSFER_DEPOSIT: 15,
		DISABLE_WITH_DRAW: 16,
		THE_SAME_TYPE: 17,
		DEDUCT_DEPOSIT_FEE_LIMIT: 18,
	},
	ActivityResultStr: {
		SUCCESS: '成功',
		FAILED: '失败',
		CONDITION_DELETE_ERROR: '活动条件设定中已有兑奖纪录，无法删除',
		UPLOAD_IMAGE_FAILED: '活动图上传失败',
		INVALID_PARAMS: '参数错误',
		ACTIVITY_NOT_FOUND: '查无此活动',
		DESCENDANTS_NOT_FOUND: '下级帐户错误',
		FREQUENT_EXECUTION: '建立活动操作频繁',
		UPDATE_WALLET_ERROR: '代理活动更新钱包失败',
		NOT_ENOUGH_MONEY: '代理资金不足',
		INVALID_DRAWPASSWORD: '尚未绑订资金密码',
		WRONG_DRAWPASSWORD: '#DrawPassword#错误',
		INVALID_GOOGLE_AUTH_PASSWORD: 'Google验证码错误',
		DIVIDEND_CONTRACT_LIMIT: '契约分红未发放',
		DAILY_PAY_LIMIT: '工资未发放',
		ENABLE_TRANSFER_DEPOSIT: '禁止转点',
		DISABLE_WITH_DRAW: '禁止提現',
		THE_SAME_TYPE: '活动类型重复',
		DEDUCT_DEPOSIT_FEE_LIMIT: '共同承担充值手续费尚未扣除',
	},
	ActivityReceiveResult: {
		SUCCESS: 0,
		FAILED: 1,
		WRONG_PARAMETER: 2,
		CONDITION_NOT_MET: 3,
		NOT_ENOUGH_DEPOSIT: 4,
		NOT_ENOUGH_BET: 5,
		NOT_ENOUGH_DEPOSIT_OR_BET: 6,
		NOT_ENOUGH_BETREQUIRED: 7,
		LOGIN_IP_IS_NULL: 8,
		RECEIVED_BY_OTHER_PLAYERS: 9,
		UNLOGIN: 10,
		INVALID_BANK_ACCOUNT: 11,
		EXCEED_QUOTA: 12,
		EXCEED_ACTIVITY_QUOTA: 13,
		EXCEED_ACTIVITY_QUOTA_PER_DAY: 14,
		EXCEED_PLAYER_QUOTA: 15,
		EXCEED_PLAYER_QUOTA_PER_DAY: 16,
		EXCEED_DEADLINE: 17,
		NOT_ALLOW_RECEIVE_PRIZE_BY_BACKEND: 18,
		PRIZE_RECEIVED: 19,
		ALL_RECEIVED: 20,
		NOT_STARTED: 21,
		REPEAT_AWARD: 22,
		NOT_ENOUGH_AMOUNT: 23,
		ACTIVITY_LOCK: 24,
		BET_DENIED: 25,
		NOT_ENOUGH_ROULETTE_QUOTA: 26,
		NOT_ENOUGH_QUOTA: 27,
		PLAYER_FUNDS_FREEZE: 28,
		DIVIDEND_DENIED: 29,
		ROULETTE_MAINTAIN: 30,
		DEDUCT_DEPOSIT_FEE_LIMIT: 31,
		NOT_ENOUGH_DRAWCOUNT: 32,
	},
	RewardState: {
		SUCCESS: '领取成功',
		FAILED: '领取失败',
		WRONG_PARAMETER: '参数错误',
		CONDITION_NOT_MET: '未达领取条件',
		NOT_ENOUGH_DEPOSIT: '充值量不足',
		NOT_ENOUGH_BET: '投注量不足',
		NOT_ENOUGH_DEPOSIT_OR_BET: '充值量或投注量不足',
		NOT_ENOUGH_BETREQUIRED: '打码量不足',
		LOGIN_IP_IS_NULL: '取得登入IP失败',
		RECEIVED_BY_OTHER_PLAYERS: '同IP或同姓名已经领取',
		UNLOGIN: '尚未登入',
		INVALID_BANK_ACCOUNT: '尚未绑定银行卡卡号',
		EXCEED_QUOTA: '已超过领取次数上限',
		EXCEED_ACTIVITY_QUOTA: '已超过活动总领取次数上限',
		EXCEED_ACTIVITY_QUOTA_PER_DAY: '已超过活动每日领取次数上限',
		EXCEED_PLAYER_QUOTA: '已超过个人总领取次数上限',
		EXCEED_PLAYER_QUOTA_PER_DAY: '已超过个人每日领取次数上限',
		EXCEED_DEADLINE: '已超过个人领取期限天数',
		NOT_ALLOW_RECEIVE_PRIZE_BY_BACKEND: '后台设定活动不可领取',
		PRIZE_RECEIVED: '已领取',
		ALL_RECEIVED: '已领取完毕',
		NOT_STARTED: '活动尚未开始',
		REPEAT_AWARD: '重复领取',
		NOT_ENOUGH_AMOUNT: '钱包余额不足',
		ACTIVITY_LOCK: '活动lock',
		BET_DENIED: '禁止投注',
		NOT_ENOUGH_ROULETTE_QUOTA: '转盘次数不足',
		NOT_ENOUGH_QUOTA: '幸运份额不足',
		PLAYER_FUNDS_FREEZE: '玩家异常无法进行活动，请联系客服人员',
		DIVIDEND_DENIED: '尚有分红契约限制',
		ROULETTE_MAINTAIN: '转盘活动维护中',
		DEDUCT_DEPOSIT_FEE_LIMIT: '尚有共同承担充值手续费限制',
		NOT_ENOUGH_DRAWCOUNT: '幸運抽獎次數不足',
	},
	ComparerItem: {
		EQUALS: { key: 0, val: '＝ (等于)' },
		GREATER_OR_EQUALS: { key: 1, val: '≧ (大于等于)' },
		LESS_OR_EQUALS: { key: 2, val: '≦ (小于等于)' },
		GREATER_THAN: { key: 3, val: '＞ (大于)' },
		LESS_THAN: { key: 4, val: '＜ (小于)' },
	},
	FieldItem: {
		DAILY_SIGNIN: { key: 1, val: '每日签到' },
		CONTINUOUS_SIGNIN: { key: 2, val: '连续签到' },
		FIRST_DEPOSIT: { key: 100, val: '每日首次充值' },
		TODAY_DEPOSIT: { key: 101, val: '每日充值' },
		CUMULATIVE_DEPOSIT: { key: 102, val: '累积充值' },
		FIRST_CONSUME: { key: 200, val: '每日首次消费' },
		TODAY_CONSUME: { key: 201, val: '每日消费' },
		CUMULATIVE_CONSUME: { key: 202, val: '累积消费' },
	},
	DailySignInType: {
		DAILY_SIGNIN: 1,
		CONTINUOUS: 2,
	},
	DailySignInRuleType: {
		LOGIN: { key: 0, val: '登入签到送' },
		FIRST_DEPOSIT: { key: 1, val: '每日首充签到送' },
		TODAY_DEPOSIT: { key: 2, val: '每日充值签到送' },
		CUMULATE_DEPOSIT: { key: 3, val: '充值签到送' },
		CUMULATE_CONSUME: { key: 4, val: '消费签到送' },
		TODAY_CONSUME: { key: 5, val: '每日消费签到送' },
		TODAY_DEPOSIT_CONSUME: { key: 6, val: '每日充值消费送' },
		CUMULATE_DEPOSIT_CONSUME: { key: 7, val: '充值消费送 ' },
	},
	ActivityStatisticsType: {
		RECEIVE_SUMMARY: 0,
		RECEIVE_DETAIL: 1,
		VIP_PLAYER_DETAIL: 2,
		VIP_LAYER_DISTRIBUTION: 3,
		VIP_LEVEL_DISTRIBUTION: 4,
		VIP_LEVEL_DISTRIBUTION_DETAIL: 5,
		PENDING_DONE: 6,
	},
	LossReturnPointActivityType: {
		LOTTERY: { key: 1, val: '彩票' },
		VIDEO_SLOT: { key: 2, val: '真人电子' },
		CARD: { key: 4, val: '棋牌' },
		SPORT: { key: 8, val: '体育' },
		YBGAME: { key: 16, val: '云豹视讯' },
	},
	LossReturnPointActivityState: {
		CANCEL: 0,
		WAITING: 1,
		PAID: 2,
		NOLOGIN: 3,
	},
	LossReturnPointActivityResult: {
		SUCCESS: 0,
		FAILED: 1,
		INVALID_INPUT: 2,
		LOGINID_NOT_EXIST: 3,
		NOT_ENOUGH_MONEY: 4,
		ALREADY_ACTIVATED: 5,
		REPEAT_ACTIVATE: 6,
		NOT_STARTED: 7,
	},
	TeamActivityMode: {
		ALL_DESCENDANT: 0,
		DESIGNATED_TEAM: 1,
		DESIGNATED_ACCOUNT: 2,
	},
	OneDollarActivityGetGifType: {
		NOT_GET: 0,
		GET: 1,
		PRIZE_RECEIVED: 2,
	},
	ActivityDisplayTypeStr: {
		RedirectExternalUrl: 'RedirectExternalUrl',
		RedirectInternalUrl: 'RedirectInternalUrl',
		ShowDetail: 'ShowDetail',
	},
	ActivityFrontEndCategoryStr: {
		Lottery: 'Lottery',
		Video: 'Video',
		Slot: 'Slot',
		Card: 'Card',
		Fish: 'Fish',
		Sport: 'Sport',
	},
	ActivityFrontEndTypeStr: {
		PC: 'PC',
		APP: 'APP',
	},
	GoogleAuthenticatorItem: {
		None: 0,
		ChangePassword: 1,
		ChangeDrawPassword: 2,
		TransferPoint: 4,
		Withdraw: 8,
		Login: 16,
		ResetDrawPassword: 32,
	},
	ThirdPartySendMethod: {
		GET: 0,
		POST: 1,
		QRCODE: 2,
		SHOW_BANK_PAGE: 3,
	},
	EPSendMethod: {
		GET: 0,
		POST: 1,
		QRCODE: 2,
	},
	DepositRequestResult: {
		SUCCESS: 0,
		INVALID_ACCOUNT: 1,
		INVALID_AMOUNT: 2,
		EMPTY_NAME: 3,
		DEPOSIT_DISABLED: 4,
		HAVE_PENDING_REQUEST: 5,
		UNKNOWN_ERROR: 6,
		NO_BANKCARD: 7,
		NO_CHANNEL: 8,
		CHANNEL_DISABLED: 9,
		CHANNEL_NOT_OPEN: 10,
		READONLY_LAYER: 11,
		MYCARD_DUPLICATE_SERIALNUMBERS: 12,
		TPP_PROXY_CONNECTION_FAILED: 13,
		PAYMENT_PLATFORM_PROXY_CONNECTION_FAILED: 14,
		INVALID_DEPOSITACCOUNT: 15,
		FAILED_TO_GET_EXCHANGE_RATE: 16,
	},
	DepositAmountMode: {
		Normal: 0,
		AutoDecimal: 1,
		UNITS_DIGIT_NOT_ZERO: 2,
	},
	DepositExaminationValidationResult: {
		SUCCESS: 0,
		UNKNOWN_ERROR: 1,
		DEPOSIT_REQUEST_NOTFOUND: 2,
		INVALID_STATE: 3,
		SAVE_FAILED: 4,
		DEPOSIT_ACCOUNT_FAILED: 5,
		COMPLETED_ORDER: 6,
		SYSTEM_BUSY: 7,
	},
	DepositTypeArray: [
		{ ID: 0, KEY: 'BANK', NAME: '网银汇款'},
		{ ID: 1, KEY: 'ONLINEPAY', NAME: '在线支付'},
		{ ID: 2, KEY: 'WEIXIN', NAME: '微信支付'},
		{ ID: 3, KEY: 'TENPAY', NAME: '财付通'},
		{ ID: 4, KEY: 'QQ', NAME: 'QQ钱包'},
		{ ID: 5, KEY: 'ALIPAY', NAME: '支付宝'},
		{ ID: 6, KEY: 'JD', NAME: '京东支付'},
		{ ID: 7, KEY: 'BAIDU', NAME: '百度支付'},
		{ ID: 8, KEY: 'UNION', NAME: '银联扫码'},
		{ ID: 9, KEY: 'QUICK', NAME: '快捷支付'},
		{ ID: 10, KEY: 'QUICKPASS', NAME: '云闪付'},
		{ ID: 11, KEY: 'OTHER', NAME: '其它'},
		{ ID: 12, KEY: 'PHONE', NAME: '手机转帐'},
		{ ID: 13, KEY: 'ALIPAYPASSWORD', NAME: '支付宝口令'},
		{ ID: 14, KEY: 'ONLINEBANK', NAME: '网银'},
		{ ID: 15, KEY: 'USDT', NAME: '虚拟币'},
		{ ID: 16, KEY: 'THIRDPARTY_USDT', NAME: 'USDT'},
		{ ID: 17, KEY: 'NOT_USING', NAME: '弃用'},
		{ ID: 18, KEY: 'MYCARD', NAME: 'MyCard'},
		{ ID: 19, KEY: 'TIKTOK', NAME: '抖音支付'},
		{ ID: 20, KEY: 'ECNY', NAME: '数字人民币'},
		{ ID: 21, KEY: 'ELECTRONIC_PURSE', NAME: '电子钱包'},
	],
	DepositType: {
		BANK: 0,
		ONLINEPAY: 1,
		WEIXIN: 2,
		TENPAY: 3,
		QQ: 4,
		ALIPAY: 5,
		JD: 6,
		BAIDU: 7,
		UNION: 8,
		QUICK: 9,
		QUICKPASS: 10,
		OTHER: 11,
		PHONE: 12,
		ALIPAYPASSWORD: 13,
		ONLINEBANK: 14,
		USDT: 15,
		THIRDPARTY_USDT: 16,
		NOT_USING: 17,
		MYCARD: 18,
		TIKTOK: 19,
		ECNY: 20,
		ELECTRONIC_PURSE: 21,
	},
	BankType: {
		BANK: { key: 'BANK', val: 0, title: '银行' },
		ALIPAY: { key: 'ALIPAY', val: 1, title: '支付宝' },
		ECNY: { key: 'ECNY', val: 2, title: '数字人民币' },
		WECHAT: { key: 'WECHAT', val: 3, title: '微信' },
	},
	DepositStoreType: {
		BANK: 0,
		TPP: 1,
		EP: 2,
		VC: 3,
	},
	DepositRequestResultStr: {
		SUCCESS: '成功',
		INVALID_ACCOUNT: '不允许的银行',
		INVALID_AMOUNT: '入款金额在允许范围外',
		EMPTY_NAME: '请输入入款姓名',
		DEPOSIT_DISABLED: '该用户充值功能已被停用',
		HAVE_PENDING_REQUEST: '尚有一笔充值未完成',
		UNKNOWN_ERROR: '未知错误',
		NO_BANKCARD: '尚未绑定银行卡',
		NO_CHANNEL: '入款渠道匹配中,请联系客服',
		CHANNEL_DISABLED: '渠道禁止使用,请重整后再做尝试',
		CHANNEL_NOT_OPEN: '该渠道未开放，如有疑问请洽客服人员',
		READONLY_LAYER: '若要开通此充值渠道，麻烦联系线上客服',
		MYCARD_DUPLICATE_SERIALNUMBERS: 'MyCard序号重复',
		TPP_PROXY_CONNECTION_FAILED: '第三方proxy连接失败',
		PAYMENT_PLATFORM_PROXY_CONNECTION_FAILED: '金流平台proxy连接失败',
		INVALID_DEPOSITACCOUNT: '无效存款人地址',
		FAILED_TO_GET_EXCHANGE_RATE: '取得汇率失败',
	},
	DepositRequestState: {
		WAITING: 0,
		CONFIRM: 1,
		CANCEL: 2,
		CREATE_ORDER: 3,
	},
	EPDepositRequestState: {
		WAITING: 0,
		CONFIRM: 1,
		CANCEL: 2,
		CREATE_ORDER: 3,
	},
	USDTWithdrawRequestState: {
		WAITING: 0,
		SUCCESS: 1,
		CANCEL: 2,
		HANDLE: 3,
		FAIL: 4,
	},
	USDTWithdrawExchangeRateState: {
		NORMAL: 0,
		WARNING: 1,
	},
	USDTDepositRequestStatus: {
		WAITING: 0,
		CONFIRM: 1,
		CANCEL: 2,
	},
	WithdrawAndDepositRecordUSDTOption: {
		NONE: 0,
		INCLUDE_USDT: 1,
		SEPERATE_USDT: 2,
	},
	WithdrawRequestState: {
		WAITING: 0,
		CONFIRM: 1,
		CANCEL: 2,
		FAILED: 3,
		UNKNOWN: 4,
		AUTOHANDLE: 5,
		THIRDPARTY_HANDLE: 6,
		THIRDPARTY_CREATEORDER: 7,
		THIRDPARTY_FAILED: 8,
	},
	EPWithdrawRequestState: {
		WAITING: 0,
		CONFIRM: 1,
		CANCEL: 2,
		FAILED: 3,
		HANDLE: 4,
		THIRDPARTY_CREATEORDER: 5,
		THIRDPARTY_FAILED: 6,
	},
	WithdrawRiskControlState: {
		WAITING: 0,
		CANCEL: 1,
		CONFIRM: 2,
	},
	WithdrawRequestValidationStatus: {
		SUCCESS: 0,
		FAILED: 1,
		NOT_ENOUGH_MONEY: 2,
		NO_CHOICE_BANKCARD: 3,
		BET_REQUIRED_NOT_ENOUGH: 4,
		WITHDRAW_DISABLE: 5,
		WRONG_PASSWORD: 6,
		BANKCARD_NOT_FOUND: 7,
		IN_BLACKLIST: 8,
		GOOGLE_VALID_FAIL: 9,
		DRAW_TIME_PERDAY_REACHED: 10,
		UNDER_MIN_DRAW_PERTIME: 11,
		OVER_MAX_DRAW_PERTIME: 12,
		OVER_MAX_DRAW_PERDAY: 13,
		DRAW_INTERVAL: 14,
		DIVIDEND_CONTRACT_LIMIT: 15,
		DAILY_PAY_LIMIT: 16,
		BANK_IN_MAINTAIN: 17,
		UNDER_MIN_DRAW_FEE: 18,
		USDT_WITHDRAWADDRESS_NOT_FOUND: 19,
		EXCHANGERATE_CHANGES: 20,
		GET_EXCHANGERATE_FAIL: 21,
		USDT_CREATE_WITHDRAW_FAIL: 22,
		LAST_DEPOSIT_NOT_USDT: 23,
		ONLY_USE_USDT_WITHDRAW: 24,
		NEVER_USED_USDT_DEPOSIT: 25,
		DISABLE_USDT_WITHDRAWAL_AFTER_DEPOSIT_RMB: 26,
		DISABLE_WITHDRAWAL_AFTER_DEPOSIT_USDT: 27,
		OVER_USDT_MAX_DRAW_PERTIME: 28,
		UNDER_USDT_MIN_DRAW_PERTIME: 29,
		USDT_DRAW_TIME_PERDAY_REACHED: 30,
		OVER_USDT_MAX_DRAW_PERDAY: 31,
		DISABLE: 32,
		USDT_ADDRESS_IN_BLACKLIST: 33,
		REPEAT_WITHDRAW: 34,
		ELECTRONIC_PURSE_NOT_BIND: 35,
		DISABLE_EP_WITHDRAWAL_AFTER_DEPOSIT_RMB: 36,
		INVALID_ADDRESS: 37,
		CHANNEL_CLOSE: 38,
		EP_IN_BLACKLIST: 39,
		DEDUCT_DEPOSIT_FEE_LIMIT: 40,
		PLEASE_CHANGE_BANK_CARD_CATEGORY: 41,
		OVER_MAX_DRAW_PERDAY_BY_BANK_CARD_CATEGORY: 42,
		OVER_DAILY_WITHDRAWAL_TOTAL: 43,
		OVER_FIRST_WITHDRAWAL_LIMIT: 44,
		PLATFORM_DEPOSIT_AND_BALANCE_CHECK_RULE: 45,
		FIRST_WITHDRAW_NEED_VERIFY: 46,
	},
	PlayerState: {
		NONE: 0,
		DISABLE_ACCOUNT: 1,
		ACCOUNT_ALARM: 2,
		DISABLE_CHAT_ROOM: 4,
		DISABLE_BET: 8,
		ENABLE_DIFFERENCE_IP: 16,
		LOCK_USER_LEVEL: 32,
		ENABLE_TRANSFER_DAILYPAY: 64,
		DISABLE_WITH_DRAW: 128,
		DISABLE_DEPOSIT: 256,
		ENABLE_TRANSFER_DEPOSIT: 512,
		ENABLE_TRANSFER_ACTIVITY: 1024,
		ENABLE_TRANSFER_DIVIDEND: 2048,
		ENABLE_TRANSFER_OTHER: 4096,
		DIVIDEND_CONTRACT_LIMIT: 8192,
		DAILY_PAY_LIMIT: 16384,
		GOOGLE_AUTH_WITHDRAW: 32768,
		GOOGLE_AUTH_TRANSFER: 65536,
		GOOGLE_AUTH_LOGIN: 131072,
		STAY_IN_NORMAL_LAYER: 262144,
		GESTURE_LOGIN: 524288,
		FENGDAN_ALERT: 1048576,
		DRAWW_ALERT: 2097152,
		WINNING_ALERT: 4194304,
		GOOGLE_AUTH_CHANGE_PWD: 8388608,
		GOOGLE_AUTH_CHANGE_DRAWPWD: 16777216,
		ENABLE_TRANSFER_SUPER: 33554432,
		FUNDS_FREEZE: 67108864,
		GOOGLE_AUTH_RESET_DRAWPWD: 134217728,
		REGISTER_LINK_LIMIT: 268435456,
		CHAT_ALERT: 536870912,
		DISABLE_BET_PASSWORD: 1073741824,
		TEAM_STATUS_IGNORES: 2147483648,
	},
	PlayerBounsState: {
		NONE: 0,
		DIRECT_AGENT_DEDUCT_DEPOSIT_FEE_LIMIT: 1,
	},
	PlayerResult: {
		SUCCESS: 0,
		ROLE_ERROR: 1,
		CLAIMS_ERROR: 2,
		PASSWORD_ERROR: 3,
		RETURN_POINT_ERROR: 4,
		REFUSE_TO_LOWER_RETURN_POINT: 5,
		CHAT_ERROR: 6,
		REGISTER_LINK_FAILURE: 7,
		LOGINID_EXISTS: 8,
		LOGINID_LENGTH_ERROR: 9,
		LOGINID_INVALID_CHAR: 10,
		LOCK_REGISTER_IP: 11,
		FAIL: 12,
		AUTH_QUESTIONS_ERROR: 13,
		PHONE_NUMBER_WRONG_FORMAT: 14,
		PHONE_NUMBER_REGISTERED: 15,
		PHONE_NUMBER_CHECKED_FAIL: 16,
		SMS_VERIFY_FAILED: 17,
		DESCENDANT_LAYER_LIMIT: 18,
		CREATE_LOGINID_FAIL: 19,
		BIRTHDAY_ENPTY: 20,
		WEIXINACCOUNT_ENPTY: 21,
		WEIXINACCOUNT_ERROR: 22,
		QQNUMBER_ENPTY: 23,
		QQNUMBER_LENGTH_ERROR: 24,
		EMAIL_ENPTY: 25,
		EMAIL_ALREADY_USE: 26,
		EMAIL_LENGTH_ERROR: 27,
		EMAIL_ERROR: 28,
		GOOGLE_AUTH: 29,
		WECHAT_RULE: 30,
		SIMPLE_PASSWORD: 31,
		DEFAULT_PASSWORD: 32,
		INVALID_PASSWORD: 33,
		RETURN_POINT_NEED_SAME_WITH_DIRECT_AGNET: 34,
		RETURN_POINT_PAY_ERROR: 35,
		USER_REGISTER_PLAYER_LIMIT_ERROR: 36,
	},
	PlayerResultStr: {
		SUCCESS: '成功',
		ROLE_ERROR: '权限配置错误，请重新尝试',
		CLAIMS_ERROR: '平台资讯配置错误，请重新尝试',
		PASSWORD_ERROR: '密码变更错误，请重新尝试',
		RETURN_POINT_ERROR: '返点配置错误请，请重新尝试',
		REFUSE_TO_LOWER_RETURN_POINT: '拒绝返点做降点配置，请重新尝试',
		CHAT_ERROR: '聊天室状态配置错误，请重新尝试',
		REGISTER_LINK_FAILURE: '推广链结失效',
		LOGINID_EXISTS: '该账号无法使用，请替换后重新尝试',
		LOGINID_LENGTH_ERROR: '账号长度错误，请替换后重新尝试',
		LOGINID_INVALID_CHAR: '账号开头需英文字母，且只能包含英文(不分大小写)、数字',
		LOCK_REGISTER_IP: '注册太频繁，暂时禁止注册',
		FAIL: '失败',
		AUTH_QUESTIONS_ERROR: '密保问题配置错误',
		PHONE_NUMBER_WRONG_FORMAT: '手机号格式错误',
		PHONE_NUMBER_REGISTERED: '手机号已被注册',
		PHONE_NUMBER_CHECKED_FAIL: '手机号检查失败',
		SMS_VERIFY_FAILED: '验证码错误',
		DESCENDANT_LAYER_LIMIT: '已达会员阶层限制',
		CREATE_LOGINID_FAIL: '账号产生失败',
		BIRTHDAY_ENPTY: '生日栏位必须输入',
		WEIXINACCOUNT_ENPTY: '微信号栏位必须输入',
		WEIXINACCOUNT_ERROR: '微信号请输入英文或数字',
		QQNUMBER_ENPTY: 'QQ号栏位必须输入',
		QQNUMBER_LENGTH_ERROR: 'QQ号效格式为 5 至 20 范围内纯数字',
		EMAIL_ENPTY: '邮箱栏位必须输入',
		EMAIL_ALREADY_USE: '邮箱已使用',
		EMAIL_LENGTH_ERROR: '邮箱不可超过50字元',
		EMAIL_ERROR: '请输入正确邮箱',
		GOOGLE_AUTH: '验证码错误或是尚未绑定系统谷歌认证',
		WECHAT_RULE: '帐号格式错误，请重新输入!!',
		SIMPLE_PASSWORD: '新密码过于简单，请重新输入!',
		DEFAULT_PASSWORD: '新密码不能设置为与预设密码相同!',
		INVALID_PASSWORD: '新密码规则不正确，请重新输入!',
		RETURN_POINT_NEED_SAME_WITH_DIRECT_AGNET: '返点值必须跟直属帐号一样大',
		RETURN_POINT_PAY_ERROR: '返点工资配置错误，请重新尝试',
		USER_REGISTER_PLAYER_LIMIT_ERROR: '限制玩家注册层级设置错误，请重新尝试',
	},
	RegisterLinkRequestResult: {
		FAIL: 0,
		SUCCESS: 1,
		NOT_ALLOWED: 2,
	},
	RegisterLinkType: {
		General: 0,
		WeChat: 1,
		Video: 2,
	},
	CODLayer: {
		Normal: { key: 0, val: 'Normal' },
		LimitLayer: { key: 1, val: '限制层' },
		SpecialLayer: { key: 2, val: '特殊层' },
		MajorLayer: { key: 3, val: '大户层' },
		InactiveLayer: { key: 4, val: '非活跃会员层' },
		NewMemberObservationLayer: { key: 5, val: '新人观察层' },
	},
	ChangePasswordResult: {
		SUCCESS: 0,
		OLD_PASSWORD_ERROR: 1,
		PASSWORD_RULE_ERROR: 2,
		FAIL: 3,
		SAME_DEFAULT_PASSWORD: 4,
		SAME_OLD_PASSWORD: 5,
		GOOGLE_PASSWORD_ERROR: 6,
		CHANGE_PASSWORD_TOKEN_ERROR: 7,
		WECHAT_CHANGE_PASSWORD_FAILED: 8,
		SIMPLE_PASSWORD: 9,
	},
	ChangePasswordResultStr: {
		SUCCESS: '成功',
		OLD_PASSWORD_ERROR: '原密码错误',
		PASSWORD_RULE_ERROR: '新密码规则不符',
		FAIL: '变更密码失敗',
		SAME_DEFAULT_PASSWORD: '新密码与预设密码相同',
		SAME_OLD_PASSWORD: '新密码与旧密码相同',
		GOOGLE_PASSWORD_ERROR: '谷歌动态码错误',
		CHANGE_PASSWORD_TOKEN_ERROR: '变更密码资讯找不到，请重新申请!',
		WECHAT_CHANGE_PASSWORD_FAILED: '微信变更密码失败',
		SIMPLE_PASSWORD: '新密码过于简单，请重新设置!',
	},
	PlayerMoveResult: {
		SUCCESS: 0,
		NONEXISTENT: 1,
		AGENT_NONEXISTENT: 2,
		NEW_AGENT_IS_CURRENT_AGENT: 3,
		IS_EQUAL: 4,
		IS_MEMBER: 5,
		ROOT_AGENT: 6,
		EXECUTING: 7,
		RETURN_POINT_INVALID: 8,
		DIRECT_AGENT_RULE_INVALID: 9,
		DIVIDEND_CONTRACT: 10,
		DAILY_PAY: 11,
		DAILY_PAY_RULE_NOT_ALLOWED: 12,
		DESCENDANT_LAYER_LIMIT: 13,
		CANNOT_MOVE_TO_ANY_DESCENDANT: 14,
		FAIL: 15,
		DIVIDEND_CONTRACT_RULE_NOT_ALLOWED: 16,
		RETURN_POINT_PAY_RULE_NOT_ALLOWED: 17,
		CG_DAILY_PAY: 20,
		CG_DAILY_PAY_RULE_NOT_ALLOWED: 21,
		AGENT_SERVICE_FEE: 22,
		AGENT_SERVICE_FEE_RULE_NOT_ALLOWED: 23,
	},
	PlayerMoveResultStr: {
		SUCCESS: '搬移成功',
		NONEXISTENT: '查无玩家资料',
		AGENT_NONEXISTENT: '查无指定上级资料',
		NEW_AGENT_IS_CURRENT_AGENT: '新代理为当前代理',
		IS_EQUAL: '移桶帐号等于指定上级帐号',
		IS_MEMBER: '指定上级帐号为会员帐号',
		ROOT_AGENT: '最上层代理、会员不允许被搬移',
		EXECUTING: '尚有未执行完成的搬移帐户，请稍候在重新尝试',
		RETURN_POINT_INVALID: '返点不得大于上级帐号',
		DIRECT_AGENT_RULE_INVALID: '移桶帐号(或是其下级)原本是直属帐号，新的代理(或其上级)不能是直属帐号',
		DIVIDEND_CONTRACT: '搬移帐户本身已与上级签订契约，因此不允许被搬移',
		DAILY_PAY: '搬移帐户本身已与上级设定日工资，因此不允许被搬移',
		DAILY_PAY_RULE_NOT_ALLOWED: '不符合日工资搬移规则，因此不允许被搬移',
		DESCENDANT_LAYER_LIMIT: '搬移帐户后超过系统限制阶层，因此不允许被搬移',
		CANNOT_MOVE_TO_ANY_DESCENDANT: '指定上级不得为任一下级',
		FAIL: '失败',
		DIVIDEND_CONTRACT_RULE_NOT_ALLOWED: '不符合契约搬移规则，因此不允许被搬移',
		RETURN_POINT_PAY_RULE_NOT_ALLOWED: '不符合返点工资搬移规则，因此不允许被搬移',
		CG_DAILY_PAY: '搬移帐户本身已与上级设定CG日工资，因此不允许被搬移',
		CG_DAILY_PAY_RULE_NOT_ALLOWED: '不符合CG日工资搬移规则，因此不允许被搬移',
		AGENT_SERVICE_FEE: '搬移帐户本身已与上级设定代理服务费，因此不允许被搬移',
		AGENT_SERVICE_FEE_RULE_NOT_ALLOWED: '不符合代理服务费搬移规则，因此不允许被搬移',
	},
	DeletePlayerResult: {
		SUCCESS: 0,
		NOT_EXIST: 1,
		DESCENDANTS: 2,
		WITHDRAWRE_QUESTS: 3,
		DAILYPAY: 4,
		DIVIDEND_CONTRACT: 5,
		EXTENRAL_GAME_RECYCLE: 6,
		EXTENRAL_GAME: 7,
		CHAT_ROOM_ERROR: 8,
		GOOGLE_AUTHENTICATOR_DISABLE: 9,
		GOOGLE_AUTHENTICATOR_FAIL: 10,
		EXECUTING: 11,
		AGENT_SERVICE_FEE: 12,
		FAIL: 13,
	},
	DeletePlayerResultStr: {
		SUCCESS: '删除成功',
		NOT_EXIST: '帐号不存在，请重新输入',
		DESCENDANTS: '玩家尚有下级',
		WITHDRAWRE_QUESTS: '玩家尚有提款单未处理',
		DAILYPAY: '玩家尚有日工资',
		DIVIDEND_CONTRACT: '玩家尚有契约',
		EXTENRAL_GAME_RECYCLE: '外接游戏资金回收失败',
		EXTENRAL_GAME: '外接游戏资金取得失败',
		CHAT_ROOM_ERROR: '删除聊天室资讯失败',
		GOOGLE_AUTHENTICATOR_DISABLE: '尚未绑定谷歌验证',
		GOOGLE_AUTHENTICATOR_FAIL: '谷歌验证失败',
		EXECUTING: '尚有未执行完成的删除帐户，请稍候在重新尝试',
		AGENT_SERVICE_FEE: '玩家尚有代理服务费',
		FAIL: '失败',
	},
	ProportionalDividendState: {
		IN_DEPOSIT: 0,
		NOTPAID: 1,
		PAID: 2,
	},
	ProportionalDividendType: {
		LOTTERY: 0,
		LOTTERY_GAME: 1,
	},
	ProportionalDividendDepositResult: {
		SUCCESS: { key: 0, val: '存入成功' },
		NOT_AGENT: { key: 1, val: '不是代理' },
		DRAW_PASSWORD_ERROR: { key: 2, val: '资金密码错误' },
		NOT_ENOUGH: { key: 3, val: '余额不足' },
		NO_ISSUE: { key: 4, val: '没有可用期数，请稍后重试' },
		LOWER: { key: 5, val: '金额低于单次保证金下限' },
		OVER_ISSUE_UPPER: { key: 6, val: '超过周期保证金上限' },
		DISABLED: { key: 7, val: '功能关闭中' },
		FAILED: { key: 8, val: '失败，请稍后重试' },
		DRAW_PASSWORD_NULL: { key: 9, val: '尚未绑定银行卡，无法存入保证金' },
		DIVIDEND_DENIED: { key: 10, val: '尚有分红契约限制，无法存入保证金' },
		PROCESSING: { key: 11, val: '处理中请稍候' },
		NOT_SUPPORT: { key: 12, val: '不支援的彩种' },
		MARGIN_FREE: { key: 13, val: '免缴保证金' },
		NOT_DIRECT_AGENT: { key: 14, val: '不是直属代理' },
		ISSUE_MARGIN_FREE: { key: 15, val: '此期免缴保证金' },
		DEDUCT_DEPOSIT_FEE_DENIED: { key: 16, val: '尚有分红契约限制，无法存入保证金' },
		NOT_IN_DEPOSIT_TIME: { key: 17, val: '非可存入时间' },
	},
	UpdateProportionalDividendCheckResult: {
		SUCCESS: { key: 0, val: '成功' },
		NOT_SUPPORT: { key: 1, val: '不支援的彩种' },
		INVALID: { key: 2, val: '错误设定' },
		INVALID_RATE: { key: 3, val: '錯誤百分比' },
		RECORD_NOT_EXIT: { key: 4, val: '记录不存在' },
		LOWER: { key: 5, val: '金额低于单次保证金下限' },
		OVER_ISSUE_UPPER: { key: 6, val: '超过周期保证金上限' },
		PLAYER_NOT_EXIT: { key: 7, val: '用户不存在' },
		FAIL: { key: 8, val: '失败' },
		ALREADY_MARGIN_FREE: { key: 9, val: '已设定免缴保证金' },
	},
	WechatType: {
		MobileLogin: 1,
		ChangePassword: 2,
		PCQRCodeLogin: 3,
		APPLogin: 4,
		Register: 5,
		APPRegister: 6,
		PCQRCodeLoginByCheck: 7,
	},
	WechatAuth: {
		SUCCESS: 0,
		ALREADY_LOGIN: 1,
		WECHAT_AUTH_FAIL: 2,
		WECHAT_NOT_FOUND: 3,
		REGISTER_LINK_FAILURE: 4,
		OTHER_ERROR: 5,
		DISABLED: 6,
		BIND_EXIST_ACCOUNT_FAIL: 7,
		EXIST_LOGINID: 8,
		SIMPLE_PASSWORD: 9,
	},
	QueryDescendantPlayerType: {
		ACTIVE_BET: 0,
		BET: 1,
		TODAY_NEW: 2,
		ONLINE: 3,
		UNLOGIN_DAY: 4,
	},
	TransferPointResult: {
		SUCCESS: 0,
		REPEAT_EXECUTION: 1,
		WITHDRAW_DISABLE: 2,
		DRAW_PASSWORD_ERROR: 3,
		NOT_ENOUGH_MONEY: 4,
		INVALID_INPUT: 5,
		DISABLED: 6,
		TYPE_NOT_MATCH: 7,
		DEPOSIT_DISABLED: 8,
		ACTIVITY_DISABLED: 9,
		DIVIDEND_DISABLED: 10,
		DIVIDEND_CONTRACT_LIMIT: 11,
		DAILYPAY_CONTRACT_LIMIT: 12,
		NOT_ENOUGH_BET_AMOUNT: 13,
		DEPOSIT_LIMIT: 14,
		SAVE_FAILED: 15,
		NOT_DESCENDANT: 16,
		WRONG_LOGINID: 17,
		GOOGLE_AUTH_PASSWORD_ERROR: 18,
		FAIL: 19,
		DIRECT_DESCENDANT_ONLY: 20,
		FIRST_BANK_CARD_LAST_DIGITS_NOT_MATCH: 21,
		IN_BLACKLIST: 22,
		ACCOUNT_NOT_EXIST: 23,
		SUPER_DISABLED: 24,
		PLAYER_FUNDS_FREEZE: 25,
		CHANNEL_NOT_SUPPORT: 26,
		DEDUCT_DEPOSIT_FEE_LIMIT: 27,
		DAILYPAY_DISABLED: 28,
	},
	TransferPointResultStr: {
		SUCCESS: '转点成功',
		REPEAT_EXECUTION: '重覆执行转点',
		WITHDRAW_DISABLE: '提现功能被停用无法转点',
		DRAW_PASSWORD_ERROR: '#DrawPassword#错误',
		NOT_ENOUGH_MONEY: '转点资金不足',
		INVALID_INPUT: '输入资料错误',
		DISABLED: '没有可转点类型',
		TYPE_NOT_MATCH: '转点类型不符合',
		DEPOSIT_DISABLED: '充值转点未开启',
		ACTIVITY_DISABLED: '活动转点未开启',
		DIVIDEND_DISABLED: '红利转点未开启',
		DIVIDEND_CONTRACT_LIMIT: '尚未发完分红',
		DAILYPAY_CONTRACT_LIMIT: '尚未发完日工资',
		NOT_ENOUGH_BET_AMOUNT: '未达出款投注量',
		DEPOSIT_LIMIT: '未达充值转点條件',
		SAVE_FAILED: '转点更新资料失败',
		NOT_DESCENDANT: '下级账号错误',
		WRONG_LOGINID: '转点账号错误',
		GOOGLE_AUTH_PASSWORD_ERROR: '谷歌动态密码错误',
		FAIL: '转点失败',
		DIRECT_DESCENDANT_ONLY: '仅能转给直接下级',
		FIRST_BANK_CARD_LAST_DIGITS_NOT_MATCH: '银行卡末号错误',
		IN_BLACKLIST: '转点功能已被停用，如有疑问请洽客服人员',
		ACCOUNT_NOT_EXIST: '平台内无此帐号',
		SUPER_DISABLED: '超级转点未开启',
		PLAYER_FUNDS_FREEZE: '玩家异常无法进行转点，请联系客服人员',
		CHANNEL_NOT_SUPPORT: '充值渠道不支援转点！',
		DEDUCT_DEPOSIT_FEE_LIMIT: '共同承担充值手续费尚未扣除',
		DAILYPAY_DISABLED: '娱乐工资转点未开启',
	},
	LoginResult: {
		SUCCESS: 0,
		DISABLED: 1,
		TOKEN_ERROR: 2,
		DEFAULT_PASSWORD: 3,
		LOCK_LOGIN_IP: 4,
		CHECK_LOGIN_IP: 5,
		FAIL: 6,
		SMS_CODE_WRONG: 7,
		GOOGLE_AUTH_LOGIN: 8,
		GOOGLE_AUTH_LOGIN_ERROR: 9,
		LOCK_GESTURE_LOGIN: 10,
		GESTURE_PASSWORD_UNSET: 11,
		GESTURE_LOGIN: 12,
		GESTURE_LOGIN_ERROE: 13,
		UNABLE_GESTURE_LOGIN: 14,
		LOCK_LOGINID: 15,
		SIMPLE_PASSWORD: 16,
		CLIENT_AUTH_ERROR: 20,
		CLIENT_AUTH_CONTINUE: 21,
	},
	TokenVerifyResult: {
		SUCCESS: 0,
		BLACKLIST: 1,
		DIFFERENT_USER: 2,
		CHANGE_PASSWORD: 3,
		FORCED_LOGOUT: 4,
	},
	LoginType: {
		NO_LOGIN: 0,
		ACCOUNT_PASSWORD: 1,
		WECHAT: 2,
		SMS_CODE: 3,
		QQ: 4,
		GESTUREPASSWORD: 5,
	},
	ImageSliderType: {
		Activity: 0,
		Url: 1,
		FixedImage: 2,
	},
	ExternalGameRecycleState: {
		PENDING: 0,
		SUCCESS: 1,
		FAIL: 2,
		LESS_THEN_MINIMUN_AMOUNT: 3,
	},
	ContractType: {
		LOTTERY: 0,
		VIDEO_SLOT: 1,
		SPORT: 2,
		CARD: 3,
		JAGUAR_LOTTERY: 4,
		MARK_SIX: 5,
	},
	DividendPayResult: {
		SUCCESS: 0,
		NO_ENOUGH_MONEY: 1,
		ALREADY_PAY: 2,
		FAILED: 3,
		ON_PAYING: 4,
	},
	DividendPayResultStr: {
		SUCCESS: '发放成功',
		NO_ENOUGH_MONEY: '余额不足',
		ALREADY_PAY: '已发放',
		FAILED: '发放失败',
		ON_PAYING: '发放中请稍后',
	},
	ContractState: {
		NoContract: { key: 0, val: '未签订' },
		Waiting: { key: 1, val: '确认中' },
		Signed: { key: 2, val: '已签订' },
		Rejected: { key: 3, val: '契约被拒绝' },
	},
	ContractUpdateResult: {
		SUCCESS: { key: 0, val: '发送成功!' },
		NOT_DESCENDANT: { key: 1, val: '不是下级!' },
		DESCENDANT_IS_NOT_AGENT: { key: 2, val: '下级非代理!' },
		NO_CONTRACT: { key: 3, val: '契约不存在!' },
		NOT_SET_LOWER_RATE: { key: 4, val: '不得降低分红比率' },
		FAILED: { key: 5, val: '发送失败，请重新尝试。' },
	},
	DividendRecordState: {
		WAITING: { key: 0, val: '尚未发放' },
		PAID: { key: 1, val: '发放完毕' },
		REQUEST_PAYMENT_OUT_OF_PLATFORM: { key: 2, val: '平台外发放确认中' },
		PAYMENT_OUT_OF_PLATFORM_ACCEPTED: { key: 3, val: '完成平台外发送' },
		FORCIBLY_PAID: { key: 4, val: '已强制发放' },
		NODIVIDEND: { key: 5, val: '不需分红' },
		CANCEL: { key: 6, val: '取消分红' },
		AGENTWALLETAMOUNTNOTENOUGH: { key: 7, val: '馀额不足' },
	},
	DirectAgentDeductDepositFeeRecordState: {
		WAITING: { key: 0, val: '未扣除' },
		PAID: { key: 1, val: '已扣除' },
		CANCEL: { key: 2, val: '取消扣除' },
	},
	ContractTypeKeyData: {
		LOTTERY: { key: 0, val: '彩票' },
		VIDEO_SLOT: { key: 1, val: '真人电子' },
		SPORT: { key: 2, val: '体育' },
		CARD: { key: 3, val: '棋牌' },
		JAGUAR_LOTTERY: { key: 4, val: '云豹视讯' },
		MARK_SIX: { key: 5, val: '六合彩' },
	},
	AutoBonusType: {
		LOTTERY: 0,
		CARD: 1,
		JAGUAR_LOTTERY: 2,
		VIDEO_SLOT: 3,
		TEAM_BONUS: 4,
		SPORT: 5,
		AGENT_BONUS: 6,
		MARK_SIX: 7,
		HIDDEN: 8,
	},
	DashboardRecordType: {
		NewMembers: 1,
		BetMembers: 2,
		BetMembersInculdeExternalGame: 3,
		TotalDepositMembers: 4,
		TotalDepositCount: 5,
		TotalDepositAmount: 6,
		TotalWithdrawMembers: 7,
		TotalWithdrawCount: 8,
		TotalWithdrawAmount: 9,
		DepositFromWalletMembers: 10,
		DepositFromWalletCount: 11,
		DepositFromWalletAmount: 12,
		FirstDepositMembers: 13,
		DepositAmount: 14,
		ThirdPartyDepositAmount: 15,
		ElectronicPurseDepositAmount: 16,
		USDTDepositAmount: 17,
		ManualDepositAmount: 18,
		WithdrawalAmount: 19,
		USDTWithdrawalAmount: 20,
		ElectronicPurseWithdrawalAmount: 21,
		ManualWithdrawAmount: 22,
		BetAmount: 23,
		PrizeAmount: 24,
		ReturnPointAmount: 25,
		ActivityAmount: 26,
		BonusAmount: 27,
	},
	DailyPayType: {
		LOTTERY: 0,
		VIDEO_SLOT: 1,
		HOUR_PAY: 2,
		BET_PAY: 3,
		EARN_PAY: 4,
		AUTO_COMMISSION: 5,
		NONAUTO_COMMISSION: 6,
		FLOAT_PAY: 7,
		SPORT: 9,
		CG_PAY: 10,
		MARK_SIX: 11,
		FUCAI3D: 12,
		P3P5: 13,
	},
	DailyPayState: {
		NO_CONTRACT: { key: 0, val: '未签订' },
		WAITING: { key: 1, val: '确认中' },
		SIGNED: { key: 2, val: '已签订' },
		REJECTED: { key: 3, val: '日工资被拒绝' },
	},
	DailyPayUpdateResult: {
		SUCCESS: { key: 0, val: '发送失败，请重新尝试。' },
		NOT_DESCENDANT: { key: 1, val: '不是下级!' },
		DESCENDANT_IS_NOT_AGENT: { key: 2, val: '下级非代理!' },
		NO_CONTRACT: { key: 3, val: '日工资不存在!' },
		HAS_RECORD_NOT_PAID: { key: 4, val: '日工未发放!' },
		FAILED: { key: 5, val: '发送失败，请重新尝试。' },
		NOT_SET_LOWER_BONUS: { key: 6, val: '待遇不可低于原设定工资!' },
		NO_TEMPLATE: { key: 7, val: '模板不存在!' },
		NO_GROUP: { key: 8, val: '群组不存在!' },
		CONTRACT_EXIST: { key: 9, val: '日工资已存在!' },
		DAILY_PAY_DISABLED: { key: 10, val: '日工资未启用' },
		NO_ACCOUNT: { key: 11, val: '帐号不存在' },
		NOT_SET_HIGHER_BONUS: { key: 12, val: '不可与下级签订高于自身的日工资' },
		AT_LEAST_ONE_RULE: { key: 13, val: '至少签订一个工资且不得为0' },
		MAX_GROUP: { key: 14, val: '群组数量超过上限' },
		MEMBER_HAS_DAILYPAY_CANT_JOIN_GROUP: { key: 15, val: '群组成员有人已签订日工资' },
		CONTRACT_RATE_HIGHER_THAN_SYSTEM_MAX: { key: 16, val: '模板工资百分比高于最高百分比' },
	},
	DailyPayRecordState: {
		WAITING: { key: 0, val: '尚未发放' },
		PAID: { key: 1, val: '已发放' },
		AMOUNT_IS_ZERO: { key: 2, val: '不需發放' },
		CANCEL: { key: 3, val: '取消發放' },
		NO_ENOUGH_MONEY: { key: 4, val: '余额不足' },
	},
	DailyPayResult: {
		SUCCESS: 0,
		NO_ENOUGH_MONEY: 1,
		ALREADY_PAY: 2,
		FAILED: 3,
	},
	DailyPayResultStr: {
		SUCCESS: '发放成功',
		NO_ENOUGH_MONEY: '余额不足',
		ALREADY_PAY: '已发放',
		FAILED: '发放失败',
	},
	MerchantManangerHintType: {
		EVENT_LOG: 1,
		DEPOSIT: 2,
		WITHDRAW: 3,
		USDT_WITHDRAW: 4,
		DEPOSIT_FROM_WALLET: 5,
		EP_WITHDRAW: 6,
	},
	DeviceType: {
		PC: 0,
		MOBILE: 1,
		OTHER: 2,
		WECHAT: 3,
		SMS: 4,
		QQ: 5,
		API: 6,
		NONE: 7,
	},
	ExternalGameClassification: {
		SLOT_MACHINE: 0,
		CARD: 1,
		SCRATCH: 2,
		VIDEO: 3,
		SPORT: 4,
		LOTTERY: 5,
		FISH: 6,
		OTHER: 255,
	},
	WithdrawExaminationResult: {
		SUCCESS: 0,
		INVALID_ID: 1,
		INVALID_STATE: 2,
		SAVE_FAILED: 3,
		SUBMIT_FAILED: 4,
		WRONG_PASSWORD: 5,
		THIRDPARTY_PROCESSING: 6,
		THIRDPARTY_PROCESSING_FAILED: 7,
		RISK_STATE_ERROR: 8,
		WAIT_AUTOWITHDRAW_TIME: 9,
		ORDER_SPLIT_FAILED: 10,
		BANK_TYPE_NOT_MATCH: 11,
		SYSTEM_BUSY: 12,
	},
	EPWithdrawExaminationResult: {
		SUCCESS: { key: 'SUCCESS', val: 0, title: '电子钱包已出款' },
		THIRDPARTY_PROCESSING: { key: 'THIRDPARTY_PROCESSING', val: 1, title: '电子钱包处理中' },
		THIRDPARTY_PROCESSING_FAILED: { key: 'THIRDPARTY_PROCESSING_FAILED', val: 2, title: '电子钱包出款失败' },
	},
	StationLetterType: {
		ALL: 1,
		ACCOUNT: 2,
		AGENT: 3,
		AGENT_IMMEDIATE: 4,
	},
	AnnouncementType: {
		Administrator: 1,
		Player: 2,
		Marquee: 3,
		Popup: 4,
		ChatSiteGroup: 5,
	},
	AccountingCashFlowType: {
		PLAYER_DEPOSIT: 1,
		AGENT_REPAYMENT: 2,
		DEPOSIT_OTHER: 3,
		PLAYER_WITHDRAW: 101,
		AGENT_LOAN: 102,
		WITHDRAW_OTHER: 103,
		DEPOSIT_TO_TRANSIT: 201,
		TRANSIT_TO_DATSANG: 202,
		TRANSIT_TO_WITHDRAW: 203,
		TRANSIT_TO_CASH: 204,
		DATSANG_TO_CASH: 205,
		OTHER: 900,
	},
	TeamRedPackRainType: {
		DIRECT: 0,
		ALL: 1,
		CUSTOMIZE: 2,
	},
	ChangePhoneNumberResult: {
		SUCCESS: 0,
		PHONE_NUMBER_EXIST: 1,
		WRONG_VERIFICATION_CODE: 2,
		PHONE_NUMBER_WRONG_FORMAT: 3,
		PHONE_NUMBER_REGISTERED: 4,
		FAIL: 5,
		PHONE_NUMBER_NOT_REGISTERED: 6,
	},
	SendPhoneVerificationCodeResult: {
		SUCCESS: 0,
		REACHLIMITATION: 1,
		LOCKED: 2,
		SENDFAILED: 3,
		WRONGPHONEFORMAT: 4,
	},
	MerchantState: {
		Enable: 0,
		Initial: 1,
		BackEndEnable: 2,
		Disable: 3,
	},
	RegisterPhoneVerifyType: {
		SMS: 0,
		GRAPHIC: 1,
	},
	UnBindWeChatResult: {
		SUCCESS: 0,
		FAIL: 1,
		NO_SUCH_PLAYER: 2,
		WRONG_DRAWPASSWORD: 3,
	},
	UnBindWeChatResultStr: {
		SUCCESS: '微信绑定解除成功',
		FAIL: '微信绑定解除失败',
		NO_SUCH_PLAYER: '查无玩家资料',
		WRONG_DRAWPASSWORD: '资金密码错误',
	},
	PowerBIEmbedInfoStatus: {
		SUCCESS: 0,
		AUTH_FAIL: 1,
		NOT_FOUND: 2,
		ERROR: 3,
	},
	ExternalVideoResult: {
		SUCCESS: 0,
		INSUFFICIENT_BET_AMOUNT: 1,
		FAILED: 2,
	},
	DisableGoogleAuthenticatorResult: {
		SUCCESS: 0,
		FAIL: 1,
		NO_SUCH_PLAYER: 2,
		GOOGLE_AUTH_PASSWORD_ERROR: 3,
	},
	DisableGoogleAuthenticatorResultStr: {
		SUCCESS: '移除谷歌验证成功',
		FAIL: '移除谷歌验证失败',
		NO_SUCH_PLAYER: '查无玩家资料',
		GOOGLE_AUTH_PASSWORD_ERROR: '谷歌验证码错误',
	},
	SetGoogleAuthenticatorWithItemResult: {
		SUCCESS: 0,
		FAIL: 1,
		NO_SUCH_PLAYER: 2,
		GOOGLE_AUTH_PASSWORD_ERROR: 3,
	},
	SetGoogleAuthenticatorWithItemResultStr: {
		SUCCESS: '修改成功',
		FAIL: '修改失败',
		NO_SUCH_PLAYER: '查无玩家资料',
		GOOGLE_AUTH_PASSWORD_ERROR: '谷歌验证码错误',
	},
	UnbindEmailResult: {
		SUCCESS: 0,
		FAIL: 1,
		NO_SUCH_PLAYER: 2,
		GOOGLE_AUTH_PASSWORD_ERROR: 3,
		WRONG_DRAWPASSWORD: 4,
		GOOGLE_AUTH_NOT_BIND: 5,
		WRONG_PASSWORD: 6,
	},
	UnbindEmailResultStr: {
		SUCCESS: '您已成功解绑邮箱',
		FAIL: '邮箱解绑失败',
		NO_SUCH_PLAYER: '查无玩家资料',
		GOOGLE_AUTH_PASSWORD_ERROR: '谷歌验证码错误',
		WRONG_DRAWPASSWORD: '资金密码错误',
		GOOGLE_AUTH_NOT_BIND: '未绑定谷歌验证',
		WRONG_PASSWORD: '登录密码错误',
	},
	USDTAddressValidationResult: {
		SUCCESS: 0,
		ERROR: 1,
		ADDRESS_EXIST: 2,
		DISABLE_BINDING: 3,
		DRAW_PASSWORD_ERROR: 4,
		ADD_ERROR: 5,
		NO_BANK_CARD: 6,
		IS_ALREADY_BINDING: 7,
		LOGIN_ID_ERROR: 8,
		WRONG_FIRST_BANK_CARD_ACCOUNT: 9,
		WRONG_FIRST_BANK_CARD_NAME: 10,
		ADDRESS_FORMAT_ERROR: 11,
		IN_BLACKLIST: 12,
	},
	USDTAddressValidationResultStr: {
		SUCCESS: 'SUCCESS',
		ERROR: '未知错误',
		ADDRESS_EXIST: '地址已存在',
		DISABLE_BINDING: '绑定功能未开启',
		DRAW_PASSWORD_ERROR: '#DrawPassword#错误',
		ADD_ERROR: '添加失败',
		NO_BANK_CARD: '尚未绑定银行卡',
		IS_ALREADY_BINDING: '重复绑定',
		LOGIN_ID_ERROR: '查无帐号',
		WRONG_FIRST_BANK_CARD_ACCOUNT: '第一张银行卡卡号错误',
		WRONG_FIRST_BANK_CARD_NAME: '与第一张银行卡姓名不符',
		ADDRESS_FORMAT_ERROR: '地址不存在',
		IN_BLACKLIST: '此地址规格不符',
	},
	CancelResult: {
		SUCCESS: 0,
		FAILED: 1,
		HAVEBEENBETPROPOSAL: 2,
	},
	USDTApiStatus: {
		FAIL: 0,
		PROCESSING: 1,
		SUCCESS: 2,
		NOT_FOUND_MERCHANT: 3,
		GET_EXCHANGERATE_FAIL: 4,
		GET_DEPOSIT_ADDRESS_FAIL: 5,
		GET_WITHDRAW_ADDRESS_FAIL: 6,
		CREATE_WITHDRAW_FAIL: 7,
		REPEAT_WITHDRAWID: 8,
		NOT_FOUND_WITHDRAWID: 9,
		USERADDRESS_ISNULL: 10,
		EXCHANGERATE_CHANGES: 11,
	},
	WithdrawRequestType: {
		BANK: 0,
		USDT: 1,
		EPAY: 2,
	},
	WithdrawTypeArray: [
		{ ID: 0, KEY: 'BANK', NAME: '银行卡'},
		{ ID: 1, KEY: 'USDT', NAME: 'USDT'},
		{ ID: 2, KEY: 'EPAY', NAME: '电子钱包'},
	],
	WithdrawTypeEnumObj: {
		BANK: { key: 'BANK', val: 0, title: '银行卡' },
		USDT: { key: 'USDT', val: 1, title: 'USDT' },
		EPAY: { key: 'EPAY', val: 2, title: '电子钱包' },
	},
	ForwardPlanSaveValidationResult: {
		SUCCESS: 0,
		FAILED: 1,
	},
	ForwardPlanLoadValidationResult: {
		SUCCESS: 0,
		FAILED: 1,
	},
	PPSyncStatus: {
		None: 0,
		Waiting: 1,
		Complete: 2,
		Fail: 3,
		Cancel: 4,
	},
	HeadImage_type: {
		NONE: 0,
		UPLOAD: 1,
		SYSTEM_PROFILE: 2,
	},
	DescendantBehavior: {
		NONE: 0,
		DISABLE_ACCOUNT: 1,
		ACCOUNT_ALARM: 2,
		DISABLE_BET: 4,
		DISABLE_WITH_DRAW: 8,
		DISABLE_DEPOSIT: 16,
		CNY_DISABLE_DEPOSIT: 32,
		CNY_DISABLE_WITHDRAW: 64,
		VC_DISABLE_DEPOSIT: 128,
		VC_DISABLE_WITHDRAW: 256,
	},
	MerchantManangerKickType: {
		BLOCKED_ACCOUNT: 1,
		CHANGE_PASSWORD: 2,
		MULTIPLE_LOGINS: 3,
	},
	BankCardState: {
		DISABLED: 0,
		ENABLE: 1,
	},
	NewbieQuestConditionType: {
		DEPOSIT_AND_WIHDRAW: 0,
		PLAN_BET: 1,
		RED: 2,
		ONEDOLLAR: 3,
		INTERESTING: 4,
		PREDICT_BET: 5,
		SIGN: 6,
		USDT_DEPOSIT_AND_WITHDRAW: 7,
	},
	DailyPayConfigType: {
		LOTTERY: 0,
		EXTERNALGAME: 1,
		SPORT: 3,
		CG: 4,
	},
	AccountCenterCheckItem: {
		None: 0,
		PASSWORD: 1,
		DRAWPASSWORD: 2,
		GOOGLEPASSWORD: 4,
		BANKCARDNAME: 8,
	},
	AccountCenterCheckResult: {
		SUCCESS: { key: 0, val: '成功' },
		FAIL: { key: 1, val: '失败' },
		NO_SUCH_PLAYER: { key: 2, val: '查无玩家资料' },
		WRONG_PASSWORD: { key: 3, val: '密码错误' },
		WRONG_DRAWPASSWORD: { key: 4, val: '#DrawPassword#错误' },
		GOOGLE_AUTH_PASSWORD_ERROR: { key: 5, val: '谷歌验证码错误' },
		GOOGLE_AUTH_NOT_BIND: { key: 6, val: '未绑定谷歌验证' },
		WRONG_BANKCARD_NAME: { key: 7, val: '错误银行卡姓名' },
	},
	EPBindResutType: {
		Fail: { key: 'Fail', val: 0, title: '失败' },
		Success: { key: 'Success', val: 1, title: '成功' },
		NoBankCard: { key: 'NoBankCard', val: 2, title: '未绑定银行卡' },
		NotExistPlayer: { key: 'NotExistPlayer', val: 3, title: '玩家不存在' },
		AlreadyBind: { key: 'AlreadyBind', val: 4, title: '已绑定过该电子钱包类型' },
		NotExistEPStoreOrDisable: { key: 'NotExistEPStoreOrDisable', val: 5, title: '电子钱包停用或不存在' },
		GetBindDataFailed: { key: 'GetBindDataFailed', val: 6, title: '取得绑定资料失败' },
		ERROR: { key: 'ERROR', val: 7, title: '发生错误' },
		BindMethodDisable: { key: 'BindMethodDisable', val: 8, title: '绑定方式未开放' },
		Blacklist: { key: 'Blacklist', val: 9, title: '该电子钱包帐号无法绑定' },
		Addr_Exist: { key: 'Addr_Exist', val: 10, title: '该电子钱包帐号已绑定' },
		PleaseEnterAccountNumber: { key: 'PleaseEnterAccountNumber', val: 11, title: '请输入帐号' },
	},
	GraphicsCaptchaResult: {
		SUCCESS: 0,
		REUSE: 1,
		EXPIRED: 2,
		DECRYPT_ERROR: 3,
		DATA_EMPTY: 4,
		SIGNATURE_ERROR: 5,
		FAIL: 6,
	},
	CurrencyType: {
		USDT_ERC20: { key: 0, val: 'USDT_ERC20' },
		USDT_TRC20: { key: 1, val: 'USDT_TRC20' },
		USDT_BSC: { key: 2, val: 'USDT_BSC' },
		USDT_TON: { key: 3, val: 'USDT_TON' },
		USDT_SOL: { key: 4, val: 'USDT_SOL' },
	},
	ImageSliderGroup: {
		Default: 0,
		IndexSecondArea: 1,
	},
	NewbieQuestRewardType: {
		NORMAL: 0,
		EXTRA: 1,
	},
	RoulettePrizeType: {
		NONE: 0,
		TREASURE: 1,
		ONEDOLLAR: 2,
		RED: 3,
		SIGN: 4,
	},
	OneDollarPayType: {
		CASH: 0,
		QUOTA: 1,
	},
	CashFlowAlertStatus: {
		Warning: { key: 0, val: '警示' },
		Normal: { key: 1, val: '正常' },
	},
	VCPArray: [
		{ ID: 0, KEY: 'USDT_ERC20', NAME: 'ERC20'},
		{ ID: 1, KEY: 'USDT_TRC20', NAME: 'TRC20'},
		{ ID: 2, KEY: 'USDT_BSC', NAME: 'BSC'},
		{ ID: 3, KEY: 'USDT_TON', NAME: 'TON'},
		{ ID: 4, KEY: 'USDT_SOL', NAME: 'SOL'},
	],
	ExamineRiskControlResult: {
		NONE: 0,
		SUCCESS: 1,
		TRANS_RECORD: 2,
		FIRST_WITHDRAW: 3,
		AMOUNT: 4,
		WITHDRAW_TIMES: 5,
		ALARM_ACCOUNT: 6,
		BET_NOT_REACH_REQUIRED: 7,
		WITHDRAW_RISK_MANAGE: 8,
		REGISTER_DAYS: 9,
		PROHIBIT_BANK_CODES: 10,
		LOTTERY_CATEGORY_RULES: 11,
		CUSTOMER_SERVICE_NOTE: 12,
		FINANCIAL_NOTE: 13,
		EARN_AMOUNT_DAY: 14,
		EARN_AMOUNT_MONTH: 15,
		ACTIVITY_AMOUNT_DAY: 16,
		RETURN_POINT_AMOUNT_DAY: 17,
		BET_RECORDS_DAY: 18,
		CYCLE_DAYS: 19,
		PERSUADE_IP: 20,
		BANKCARD_NAME: 21,
	},
	ExamineRiskControlResultStr: {
		0: { key: 'NONE', title: 'NONE' },
		1: { key: 'SUCCESS', title: 'SUCCESS' },
		2: { key: 'TRANS_RECORD', title: '外接转回必审' },
		3: { key: 'FIRST_WITHDRAW', title: '第一次出款' },
		4: { key: 'AMOUNT', title: '自动风控审核金额' },
		5: { key: 'WITHDRAW_TIMES', title: '提款次数' },
		6: { key: 'ALARM_ACCOUNT', title: '警示帐号' },
		7: { key: 'BET_NOT_REACH_REQUIRED', title: '未达码量' },
		8: { key: 'WITHDRAW_RISK_MANAGE', title: '出款风险管理' },
		9: { key: 'REGISTER_DAYS', title: '注册未满天数' },
		10: { key: 'PROHIBIT_BANK_CODES', title: '银行黑名单' },
		11: { key: 'LOTTERY_CATEGORY_RULES', title: '彩种' },
		12: { key: 'CUSTOMER_SERVICE_NOTE', title: '客服备注' },
		13: { key: 'FINANCIAL_NOTE', title: '财务备注' },
		14: { key: 'EARN_AMOUNT_DAY', title: '当日盈利金额' },
		15: { key: 'EARN_AMOUNT_MONTH', title: '当月盈利金额' },
		16: { key: 'ACTIVITY_AMOUNT_DAY', title: '当日活动金额' },
		17: { key: 'RETURN_POINT_AMOUNT_DAY', title: '当日反水金额' },
		18: { key: 'BET_RECORDS_DAY', title: '当日投注笔数' },
		19: { key: 'CYCLE_DAYS', title: '周期投注天数' },
		20: { key: 'PERSUADE_IP', title: '劝退IP' },
		21: { key: 'BANKCARD_NAME', title: '银行卡姓名' },
	},
	WinningNumberFormatterType: {
		OriginalNumber: 0,
		TWPK10_TakeFirstLastSumRankDESC: 1,
		TronHash_Last5Digits: 2,
		Predict_FirstDigit: 3,
		QiXingCai_First4Digits: 4,
		Lucky28_From1_Take6Sum3Times: 5,
		KENO_From1_Take4Sum5TimesASC: 6,
		KENO_From4_Take3Sum5TimesASC: 7,
		TronHash_PK10Format: 8,
		TronHash_Kuai3Format: 9,
		TronHash_BlockHashLast5Digits: 10,
		TronHash_BlockHashDirectResult: 11,
		TW3D_From1_Take6Sum3Times: 12,
		TronHash_ElevenFiveBlockHashDirectResult: 13,
		TronHash_PK10BlockHashDirectResult: 14,
		TronHash_Kuai3BlockHashDirectResult: 15,
	},
	BankCardValidationResult: {
		SUCCESS: 0,
		INVALID_ACCOUNT: 1,
		REPEAT_ACCOUNT: 2,
		WRONG_PASSWORD: 3,
		INVALID_FIRST_BANK_ACCOUNT: 4,
		WRONG_FIRST_BANK: 5,
		REPEAT_NAME: 6,
		WRONG_GOOGLE_AUTH_PASSWORD: 7,
		WRONG_FIRST_NAME: 8,
		MAX_BANK_CARDS: 9,
		CHANGE_PASSWORD_FAILED: 10,
		WRONG_WEIXIN_ACCOUNT: 11,
		IN_BLACKLIST: 12,
		WRONG_PHONE_NUMBER: 13,
		CHECK_INVALID: 14,
		SAME_AS_LOGIN_PASSWORD: 15,
		BANK_CARD_LOCKE: 16,
		LEAST_ONE_DIGITAL_ENGLISH_SPECIAL_SYMBOL: 17,
		NULL_BRANCH: 18,
		ACCOUNT_LENGTH_ERROR: 19,
		FREQUENCY_IS_TOO_FAST: 20,
		API_VERIFY_FAIL: 21,
		API_VERIFY_ERROR: 22,
		DISABLE: 23,
		FAIL: 24,
		Please_Select_Bank_Card_Category: 25,
		GOOGLE_VALID_FAIL: 26,
	},
	RetryPendingTransferResult: {
		DONE: 0,
		FAIL: 1,
		ONGOING: 2,
	},
	BankCardCategory: {
		NONE: { key: 0, val: '未绑定' },
		TYPE_ONE: { key: 1, val: '一类卡' },
		TYPE_TWO: { key: 2, val: '二类卡' },
	},
	ChatSiteGroupRoomDailyBetType: {
		LOTTERY: 1,
		EXTERNAL_GAME: 2,
		LOTTERY_AND_EXTERNAL_GAME: 3,
	},
	DepositChannelValidationError: {
		None: { key: 'None', val: 0, title: 'None' },
		Layer: { key: 'Layer', val: 1, title: '层级' },
		DeactivationAmount: { key: 'DeactivationAmount', val: 2, title: '停用金额' },
		PaymentStatus: { key: 'PaymentStatus', val: 4, title: '支付平台状态(总后台)' },
		BalancePush: { key: 'BalancePush', val: 8, title: '余额推送' },
		CNYDisabled: { key: 'CNYDisabled', val: 16, title: '人民币禁用' },
		VCDisabled: { key: 'VCDisabled', val: 32, title: '虚拟币禁用' },
		SingleChanne: { key: 'SingleChanne', val: 64, title: '单一渠道' },
	},
	AgentServiceFeeUpdateResult: {
		SUCCESS: { key: 0, val: '成功' },
		NOT_DESCENDANT: { key: 1, val: '不是下级!' },
		DESCENDANT_IS_NOT_AGENT: { key: 2, val: '下级非代理!' },
		FAILED: { key: 3, val: '发送失败，请重新尝试。' },
		NOT_SET_LOWER_RATE: { key: 4, val: '百分比不可低于原设定百分比!' },
		NOT_SET_LOWER_TEMAPLATE_RATE: { key: 5, val: '该模组会降低此用户制度，故无法使用' },
		NO_TEMPLATE: { key: 6, val: '模组不存在!' },
		NO_GROUP: { key: 7, val: '群组不存在!' },
		AGENT_SERVICE_FEE_DISABLED: { key: 8, val: '代理服务费未启用' },
		NO_ACCOUNT: { key: 9, val: '帐号不存在' },
		NOT_SET_HIGHER_RATE: { key: 10, val: '不可与下级签订高于自身或系统最高的百分比' },
		MAX_TEMPLATE: { key: 11, val: '模组数量超过上限' },
		MAX_GROUP: { key: 12, val: '群组数量超过上限' },
		WRONG_FORMAT: { key: 13, val: '格式错误' },
	},
	SpeedTestRequestType: {
		H5: 0,
		App: 1,
	},
	USDTWithdrawalFeeUnit: {
		PERCENTAGE: { key: 'PERCENTAGE', val: 0, title: '百分比' },
		FIXED_VC_AMOUNT: { key: 'FIXED_VC_AMOUNT', val: 1, title: '颗数' },
	},
	ExternalGameState: {
		ONLINE: 0,
		MAINTAIN: 1,
		INTERVAL: 2,
	},
	FrontEndType: {
		NONE: 0,
		HOT: 1,
		NEW: 2,
	},
	LotteryGameHotNewState: {
		NONE: 0,
		HOT: 1,
		NEW: 2,
	},
	FirstWithdrawalVerificationItemStatus: {
		NoNeedVerify: 0,
		Error: 1,
		Success: 2,
		DataNotFound: 3,
		DrawPasswordIncorrect: 4,
		FirstBankCardNumberIncorrect: 5,
		NameIncorrect: 6,
		AuthAnswerIncorrect: 7,
	},
	FirstWithdrawalVerificationItem: {
		None: 0,
		BankCardName: 1,
		FirstBankCardNumber: 2,
		AuthQuestion: 4,
		DrawPassword: 8,
	},
	LottoCategoryProfitGroup: {
		1:[1,2,3,23,69,90],
		4:[4,5,6],
		7:[7,8,24],
		9:[9,10],
		11:[11,12,13],
		14:[14,15,16],
		17:[17,18],
		19:[19,20],
		21:[21,22],
		30:[30],
		83:[83],
		84:[84],
		98:[98],
		109:[109],
		114:[114],
		119:[119],
		120:[120],
		121:[121],
		122:[122],
},
	LotteryWinNumLength: {
		1: 5,
		7: 3,
		9: 5,
		10: 5,
		11: 3,
		14: 10,
		4: 5,
		2: 5,
		8: 3,
		5: 5,
		3: 5,
		6: 5,
		12: 3,
		15: 10,
		13: 3,
		16: 10,
		21: 3,
		23: 5,
		69: 5,
		17: 20,
		19: 8,
		18: 20,
		20: 8,
		22: 3,
		83: 1,
		84: 5,
		28: 4,
		90: 5,
		93: 64,
		98: 7,
		109: 6,
		114: 5,
		119: 7,
		120: 7,
		121: 7,
		122: 8,
	},
	ExternalGameSWTypes: [
		62,
		64,
		65,
		66,
		68,
		69,
		70,
		72,
		81,
		82,
		83,
		85,
		86,
		87,
		88,
		89,
		90,
		91,
		92,
	],
};
